import React, { Component } from 'react';
import { Link, useNavigate, Navigate, withNavigate } from "react-router-dom";
import axios from 'axios';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import { BaseUrl, BaseAssetUrl } from '../common/config';
import Popup from '../common/popup';
import Loader from '../common/loader';
import CommonAlert from '../common/Commonalert';
import SweetAlert from 'react-bootstrap-sweetalert';
import darkinfo from '../assets/images/dark-info.svg';
import whiteinfo from '../assets/images/color-info.svg';
import discountIcon from '../assets/images/discount-icon.png';

import Cartitem1 from '../assets/images/pcart-item-1.jpg';
import Cartitem2 from '../assets/images/pcart-item-2.jpg';
import Cartitem3 from '../assets/images/pcart-item-3.jpg';
import FreeProductPopup from './Freeproduct';
import FreeProductListPopup from './Freeproductlist';
import NoImage from '../assets/images/no-image.jpg';
import CartCommonImage from '../assets/images/prod-icon.png';
var NewArray = [];

 
class Checkout extends Component {

    constructor(props) {

        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

        super(props);
        this.state = {
            products: [],
            tempproducts: [],
            loading: false,
            searchText: "",
            cartAdded: (localStorage.getItem('cartItems') ? (JSON.parse(localStorage.getItem('cartItems')).length > 0 ? true : false) : false),
            pageTitle: "",
            showCartMessage: false,
            cartMsgType: "",
            cartMessage: "",
            cartSubTotal: 0,
            cartTotal: 0,
            popupVis: false,
            popupImg: false,
            viewImage: "",
            viewInfo: "",
            viewFreeProductInfo: '',
            productImageIndex: "",
            reloadCart: true,
            cartQty: [],
            allergens: [],
            ingredientsHigh: [],

            // allergens: ['CELERY', 'CEREALS CONTAINING GLUTEN', 'CERELAS', 'GLUTENS', 'GLUTEN',  'WHEAT', 'BARLEY', 'OATS', 'CRUSTACEANS', 'CRUSTACEAN', 'EGGS', 'EGG', 'FISH', 'LUPIN', 'MILK', 'MOLLUSCS', 'MUSTARD', 'PEANUTS', 'SESAME SEEDS', 'SESAME', 'SOYBEANS', 'SULPHUR DIOXIDE', 'SULPHITES', 'SULPHITE', 'TREE NUTS', 'NUTS', 'WHEAT GLUTEN', 'SOYA', 'CEREALS', 'CEREAL', 'SOY'],
            // ingredientsHigh: ['CELERY', 'CEREALS CONTAINING GLUTEN', 'CERELAS',  'GLUTENS', 'GLUTEN', 'WHEAT', 'BARLEY', 'OATS', 'CRUSTACEANS', 'CRUSTACEAN','EGGS', 'EGG', 'FISH', 'LUPIN', 'MILK', 'MOLLUSCS', 'MUSTARD', 'PEANUTS', 'SESAME SEEDS', 'SESAME', 'SOYBEANS', 'SULPHUR DIOXIDE', 'SULPHITES', 'SULPHITE', 'TREE NUTS', 'NUTS', 'PRAWN', 'CRAB', 'LOBSTER', 'MUSSELS', 'OYSTERS', 'ALMONDS', 'HAZELNUTS', 'WALNUTS', 'BRAZIL NUTS', 'CASHEWS', 'PECANS', 'PISTACHIOS', 'MACADAMIA NUTS', 'WHEAT GLUTEN', 'SOYA', 'CEREALS', 'CEREAL', 'SOY'],

            checkedItems:(localStorage.getItem('freeProductIds') !=='' && localStorage.getItem('freeProductIds') !== undefined ? [localStorage.getItem('freeProductIds')] : []),
            checkedItems2:(localStorage.getItem('freeProductIds') !=='' && localStorage.getItem('freeProductIds') !== undefined ? [localStorage.getItem('freeProductIds')] : []),
            offerproducts: '',
            freeProductData:[],
            disableButton:true,
            errorMessage:'',
            common_alert_popup: false,
            common_alert_message: '',
            removeFreeProduct: [],
            removeFreeProductQty:'',
            cartLoader: false,
            freeProductIds: (localStorage.getItem('freeProductIds') !=='' && localStorage.getItem('freeProductIds') !== undefined ? new Array(localStorage.getItem('freeProductIds')) : []),
            freeProductOpen: false,
            delete_item_popup_free: false,
            delete_item_popup_free_message: '', 
            offerProductQty: '',
            addtoCartTypeQty: 0,
            freeProductQty: 1,
            productValueIndex:[],
            offerproductQtyRemaing: 0,
            decrease_alert_popup: false,
            decrease_alert_popup_message: '',
            decreaseItem: [],
            delete_item_alert_popup: false,
            delete_single_Item: [],
            delete_item_alert_message: '',
            removeProduct:[],
            navigate: false,
            minmumAmountError:false,
            cartOriginalTotal: 0,
            imageDetails: '',
            settingsList:[],
            taxProductTotalAmount: 0,
            vatTaxAmount: 0,
            imageHover: false,
            hoverImageUrl: '',
            offerCombineProducts: [],
            offerCombineFreeProducts: [],
            freeProductDataFour: [],
            freeProductDataFive: [],
            minimumOrderAmount: 0,
            freeProductListOpen: false,
            offerProductData: [],
            filterByValue: '',
            isElementVisible: false,
            isElementVisibleMobile: false, 
            filterSelectedValue: [],
            filterValueList: [],
            accountObjective1: (loginDetails.accountObjective1 !== '' && loginDetails.accountObjective1 > 0  ? parseInt(loginDetails.accountObjective1) : 4),
            accountObjective2: (loginDetails.accountObjective2 !== '' && loginDetails.accountObjective2 > 0  ? parseInt(loginDetails.accountObjective2) : 5),
            groupProductsList: [],
            groupFilterList: [],
            minimumOrderAmounterror: false,
            decreaseDelete: false,
        };

        this.handlePopup = this.handlePopup.bind(this);
        this.handleImage = this.handleImage.bind(this);
        this.updateStateValue = this.updateStateValue.bind(this);
        this.handleChangeSearch = this.handleChangeSearch.bind(this);

        //console.log(localStorage.getItem("sitemaintanance"), 'dsd');

        if (localStorage.getItem("sitemaintanance") == '1'){
            window.location.href = '/sitemaintanance';
        }else if (!localStorage.getItem("isLoggedIn")){
            window.location.href = '/';
        }

        this.setState({ loading: true });
        this.getSettings();

        this.imgRef  = React.createRef();
        this.paneRef  = React.createRef();
        this.inlineContainerRef = React.createRef();
        this.dropdownRef = React.createRef();
        this.dropdownMobileRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleClickOutsideMobile = this.handleClickOutsideMobile.bind(this);

    }

    componentDidMount() {

        this.getProductCategories();
        this.offerProduct();
        this.allergensList();
        this.ingredientsList();

        document.addEventListener("mousedown", this.handleClickOutside);
        document.addEventListener("mousedown", this.handleClickOutsideMobile);

        var minimumOrderAmounterror = localStorage.getItem("minimumOrderAmounterror");

        if(minimumOrderAmounterror == 'Yes'){

            this.setState({minimumOrderAmounterror: true });
        }
    }
 
   componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener("mousedown", this.handleClickOutsideMobile);
   }

   handleClickOutside = (event) => {
    if (this.dropdownRef && !this.dropdownRef.current.contains(event.target)) {
      // Clicked outside the dropdown, close it here
      // You can add your logic to close the dropdown

        this.setState({isElementVisible: false });
    }
   };


   handleClickOutsideMobile = (event) => {
    if (this.dropdownMobileRef && !this.dropdownMobileRef.current.contains(event.target)) {
       this.setState({isElementVisibleMobile: false });
    }
   };

    allergensList(){

        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }
        

        let URL = BaseUrl + "allergenlist";
         axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
            let responseData = response.data.data;
            var allergendata = [];
                responseData.map((item)=>{
                 allergendata.push(item.allergenTitle);
                });
            this.setState({ allergens: allergendata});

         }).catch((err) => {
            console.log(err);
         });
    }

    ingredientsList(){

        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }
        
        let URL = BaseUrl + "ingredientlist";
         axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
            let responseData = response.data.data;
            //console.log(responseData, 'responseData');
            var ingredients = [];
                responseData.map((item)=>{
                 ingredients.push(item.ingredientTitle);
                });
            this.setState({ ingredientsHigh: ingredients});
         }).catch((err) => {
            console.log(err);
         });
    }

    getSettings(){

     var loginDetails = {};
     if (localStorage.getItem('authData')) {
        loginDetails = JSON.parse(localStorage.getItem('authData'));
     }

     let URL = BaseUrl + "settings";
         axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
            let responseData = response.data.data[0];
            if(responseData !==''){

            this.setState({ settingsList: responseData, minimumOrderAmount: responseData.minimumOrderAmount });
           }
         }).catch((err) => {
            console.log(err);
         });
    }

    updateStateValue() {
        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var cartTotal = 0;
        var subTotal = 0;
        cartItems.map(function (cartItem) {

        if(cartItem.product_type === 'Normal'){
            if (cartItem.qty > 0 ) {
                this.setState({ [cartItem.productNumber]: cartItem.qty, freeProductIds: '' });
                cartTotal += parseFloat(cartItem.PDP_Price1) * cartItem.qty;
                subTotal  += parseFloat(cartItem.PDP_Price1) * cartItem.qty;
            } else {
                //console.log(this.state[cartItem.productNumber]);
                this.setState({ [cartItem.productNumber]: 0});
            }
        }

        }, this);

       var totalAmount = 0;
       var TaxAmount = 0;
       
        if(cartItems !=='' && cartItems !== null){
            cartItems.map((taxItem)=>{
                if(taxItem.productTaxVal > 0){
                    totalAmount += taxItem.PDP_Price1 * taxItem.qty;
                }
            });
        }

        if(totalAmount > 0){
           TaxAmount = (totalAmount/100)*20;  
           cartTotal = cartTotal + TaxAmount;
        }
    
        this.setState({ cartSubTotal: this.priceFormat(subTotal), cartTotal: this.priceFormat(cartTotal), cartOriginalTotal: cartTotal, clear_cart:false, delete_item_popup: false, minmumAmountError: false, taxProductTotalAmount: totalAmount,vatTaxAmount: TaxAmount });

        this.checkOfferProductQty();

        var current = this;

        setTimeout(function(){
            current.setState({cartLoader: false});
        }, 500);
    }

    checkOfferProductQty(){

        var cartItemsLast = JSON.parse(localStorage.getItem("cartItems"));
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;

        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;
        var offerProductLastQty = 0;
        var typeFree = 0;

        var removeProduct = this.state.removeProduct;

        if(offerproductsList !== '' && cartItemsLast !== ''){
         
          cartItemsLast.map((freeItem)=>{
           stringSplit.filter(function(value) {
            if(freeItem.productNumber === value){
                offerProductLastQty += freeItem.qty;
            }
           });
          });

        }

        this.setState({offerProductQty: offerProductLastQty});
    }

    increaseQtyProduct(e, item){

        e.preventDefault();

        var productIncreaseQty = document.getElementById('product_number_'+item.productNumber).value;

        // if(productIncreaseQty > 0){

            this.setState({ [item.productNumber]: parseInt(productIncreaseQty) + 1});
        // }

    }


    dereaseQtyProduct(e, item){

        e.preventDefault();

        var productDecreaseQty = document.getElementById('product_number_'+item.productNumber).value;

        console.log(productDecreaseQty, 'productIncreaseQty');

        var cartItemsCheck = JSON.parse(localStorage.getItem("cartItems"));
        var productExist = 0;

        cartItemsCheck.map((cartItem) => {
             if(cartItem.productNumber === item.productNumber){
                productExist++;
              }            
         });


        if(productDecreaseQty == '1' && productExist !== 0){

            this.setState({ [item.productNumber]: 1});

            var cartItems = JSON.parse(localStorage.getItem("cartItems"));

            var newitems = [];
            var offerproductsList = this.state.offerproducts;
            var productToBeAdded = '';
            var stringSplit = this.state.offerCombineProducts;
            if(offerproductsList !== '' && offerproductsList !==''){
             productToBeAdded = offerproductsList.productToBeAdded;
             //stringSplit = productToBeAdded.split(',');
            }

            var typeFree = 0;
            var rice_product = 0;
            var existFree = '';

            if(cartItems.some((cartItem) => cartItem.product_type == 'Free')) {
                typeFree = 1;
            }

            var previousofferProductQty = 0;
            var returnProductNumber = 0;
            var previousQty = 0;
            var oldRice = '';
            var freeProductCount = 0;
            var freeProductQtyCount = 0;

            if(stringSplit !== ''){

            cartItems.map((cartItem) => {

              if(cartItem.productNumber === item.productNumber){
                 previousQty = cartItem.qty;
               }

              if(cartItem.product_type === 'Free'){
                existFree = '1';
                freeProductCount++;
                freeProductQtyCount += cartItem.qty;
              }

              if(this.state.freeProductDataFive.includes(cartItem.productNumber) === true && cartItem.product_type == 'Free'){

                  rice_product = '6587';
              }

              stringSplit.filter(function(value) {

                if(value ===  item.productNumber){
                    returnProductNumber = value;
                }

                if(value === cartItem.productNumber && cartItem.product_type !== 'Free'){
                    previousofferProductQty += cartItem.qty;
                 }

                 });

                });

               }

             var check_product_qty = previousofferProductQty - previousQty;

             //console.log(check_product_qty, 'check_product_qty');
    
              var CheckFreeProductDelete = this.checkProductDeleteNew(item, productDecreaseQty);

               //console.log(returnProductNumber, freeProductCount,CheckFreeProductDelete, freeProductQtyCount, 'dereaseQtyProduct');
    
                if(returnProductNumber !== 0 && freeProductCount == 0  && CheckFreeProductDelete == 0){
                   this.setState({delete_item_alert_popup: true, delete_single_Item: item, delete_item_alert_message: 'Are you sure you want to delete this item?'});
                   return false;
                }

                if(returnProductNumber !== 0 && freeProductQtyCount == 1 && freeProductCount == 1 && CheckFreeProductDelete == 0){
                   this.setState({delete_item_alert_popup: true, delete_single_Item: item, delete_item_alert_message: 'If you reduce your cart quantity, it will clear your FREE products.'});
                   return false;
                }    

    
                if(returnProductNumber !== 0 && freeProductCount > 1 && CheckFreeProductDelete == 0){
                   this.setState({delete_item_alert_popup: true, delete_single_Item: item, delete_item_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.'});
                   return false;
                }


                if(rice_product !== 0 && check_product_qty < this.state.accountObjective2 && returnProductNumber !== 0){

                 this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', common_alert_popup: true, removeFreeProduct: item, freeProductOpen:false, delete_item_popup_free: false,  delete_item_popup: false, addtoCartTypeQty:0});

                  return false;
                
                }


                if(typeFree == 1 && rice_product == 0 && check_product_qty < this.state.accountObjective1 && returnProductNumber !== 0){

                 this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', common_alert_popup: true, removeFreeProduct: item, freeProductOpen:false, delete_item_popup_free: false, delete_item_popup: false, addtoCartTypeQty:0});
                 
                  return false;
                }

               //console.log(typeFree, previousofferProductQty, this.state.accountObjective1, this.state.accountObjective2, rice_product,  returnProductNumber, 'currentDateFormat');

              if(typeFree == 1 && previousofferProductQty == this.state.accountObjective1 && returnProductNumber !== 0){
              this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', delete_item_popup_free: true, delete_item_popup_free_message: 'If you reduce your cart quantity, which will remove your free product?', removeProduct: item, freeProductOpen:false});
              return false;

              }else if(typeFree == 1 && rice_product !== 0 && previousofferProductQty == this.state.accountObjective2 && returnProductNumber !== 0){

              this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', delete_item_popup_free: true, delete_item_popup_free_message: 'If you reduce your cart quantity, which will remove your free product?', removeProduct: item, freeProductOpen:false });
                return false;

              }else{

               if(returnProductNumber !== 0 && previousQty !== 0){

               this.setState({common_alert_popup: false, delete_item_popup_free:false, clear_cart: false, delete_item_popup: true, removeProduct: item, freeProductOpen:false,  decreaseDelete: true});
               return false;

              }else{

               if(previousQty !== 0){

               this.setState({common_alert_popup: false, delete_item_popup_free:false, clear_cart: false, delete_item_popup: true, removeProduct: item, freeProductOpen:false, decreaseDelete: true});
                return false;

              }else{

                this.setState({ [item.productNumber]: 0});
              }

              }

             }

            return false;
          }
   
         if(productDecreaseQty > 0){

            this.setState({ [item.productNumber]: parseInt(productDecreaseQty) - 1});
         }

    }


    increaseQty(e,item) {

        e.preventDefault();

           if(item.product_type === 'Free'){
            return false;
           }

            this.setState({ loading: true, reloadCart: false, cartLoader: true, freeProductOpen:false, minmumAmountError: false });

            var cartItems = JSON.parse(localStorage.getItem("cartItems"));
            var offerproductsList = this.state.offerproducts;
            var productToBeAdded = '';
            var stringSplit = this.state.offerCombineProducts;

            if(offerproductsList !== '' && offerproductsList !==''){
               productToBeAdded = offerproductsList.productToBeAdded;
             // stringSplit = productToBeAdded.split(',');
            }


            // Update cart item quantity if already in cart
            var newitems = [];

            if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === item.productNumber && cartItem.product_type === 'Normal'))) {

                newitems = cartItems.map((cartItem) => 

                cartItem.productNumber === item.productNumber && cartItem.product_type === 'Normal'
                        ? {
                            ...cartItem,
                            qty: cartItem.qty + 1
                        }
                        : cartItem
                
                );
            }

            localStorage.setItem('cartItems', JSON.stringify(newitems));
            this.updateStateValue();

            var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));
            var typeFree = 0;
            if(cartItemsNew.some((cartItem) => cartItem.product_type === 'Free')) {
                typeFree = 1;
            }

            var offerProductQty = 0;
            var LastRiceProduct = 0;
            var returnProductNumberNew = 0;

            if(stringSplit !==''){
               stringSplit.filter(function(value) {
                if(item.productNumber === value){
                   returnProductNumberNew = value
                }
            });

            cartItemsNew.map((cartItem) => {

                if(cartItem.product_type === 'Free' && this.state.freeProductDataFive.includes(cartItem.productNumber)){

                    LastRiceProduct = cartItem.productNumber;
                }

                stringSplit.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductQty += cartItem.qty;
                    }
                });
             });

            }

            var offerproductQtyRemaing = 0;
            var productFourqty  = 0;
            var productFiveqty  = 0;
            var totalCount = 0;
            var totalCount1 = 0;
            var calculatedTotal = 0;

             cartItemsNew.map((freeItem)=>{

                var increment = this.state.accountObjective1;
                var increment1 = this.state.accountObjective2;

               if(freeItem.product_type === 'Free'){

                  if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                    increment1 = this.state.accountObjective2;
                    productFiveqty = freeItem.qty;
                  }else{
                    increment = this.state.accountObjective1;
                    productFourqty += freeItem.qty;
                  }

                  totalCount = increment * productFourqty;
                  totalCount1 = increment1 * productFiveqty;

                  calculatedTotal = totalCount + totalCount1;

                  offerproductQtyRemaing = offerProductQty - calculatedTotal;
               }

              });

             if(typeFree === 0){
               offerproductQtyRemaing = offerProductQty;
             }

             localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
             localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

            if(typeFree == '0' && offerProductQty >= this.state.accountObjective1 && this.state.accountObjective1 <= offerProductQty && returnProductNumberNew !== 0){
                this.setState({checkedItems: new Array(localStorage.getItem("freeProductIds")), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});

            }else if(typeFree == '0' && offerProductQty <= 5 && this.state.accountObjective1 <= offerProductQty && returnProductNumberNew !== 0){
              this.setState({checkedItems: new Array(localStorage.getItem("freeProductIds")), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});
            }else if(typeFree == '1' && offerProductQty <= 5 && this.state.accountObjective1 <= offerProductQty && returnProductNumberNew !== 0){
            this.setState({checkedItems: new Array(localStorage.getItem("freeProductIds")), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});
            }

            if(typeFree == '1' && offerProductQty > this.state.accountObjective2 && returnProductNumberNew !== 0){

                var fourValue = this.state.accountObjective1;
                var fiveValue = this.state.accountObjective2;
                var retunrFour4 = this.checkIfMultiple(offerProductQty, fourValue);
                var retunrFour5 = this.checkIfMultiple(offerProductQty, fiveValue);

                if(retunrFour4 === true){

                  this.setState({checkedItems2: localStorage.getItem("freeProductIds"), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});

                }

                if(retunrFour5 === true){

                    this.setState({checkedItems2: localStorage.getItem("freeProductIds"), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});

                }
            }

        this.setState({ reloadCart: true, loading: false});

    }

    decreaseQty(e, item) {

        e.preventDefault();

        if(item.product_type === 'Free'){
         return false;
        }

        this.setState({ freeProductOpen:false, minmumAmountError: false });

        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        // Update cart item quantity if already in cart
        var newitems = [];
        var offerproductsList = this.state.offerproducts;

        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;
        if(offerproductsList !== ''){
        var productToBeAdded = offerproductsList.productToBeAdded;
        //var stringSplit = productToBeAdded.split(',');
        }
        var typeFree = 0;
        var freeProductCount = 0;
        var rice_product = 0;

        if(cartItems.some((cartItem) => cartItem.product_type === 'Free')) {
            typeFree = 1;
        }

        if(item.product_type === 'Free'){
            this.setState({common_alert_message: 'Are you sure you want to delete your free product?', common_alert_popup: true, removeFreeProduct: item, freeProductOpen:false });
            return false;
        }

        var previousofferProductQty = 0;
        var returnProductNumber = 0;
        
        if(stringSplit !== ''){
            cartItems.map((cartItem) => {

                if(cartItem.product_type === 'Free'){
                    freeProductCount++;
                }

                if(this.state.freeProductDataFive.includes(cartItem.productNumber) && cartItem.product_type === 'Free'){
                    rice_product = '6587';
                }

                stringSplit.filter(function(value) {
                   if(value === cartItem.productNumber && cartItem.product_type !== 'Free'){
                      previousofferProductQty += cartItem.qty;
                   }
                });

             });
         }


        if(stringSplit !== ''){

            stringSplit.filter(function(value) {
               if(value ===  item.productNumber){
                  returnProductNumber = value;
               }
            });

         }


        var decreaseNumber = item.qty - 1;

        var check_product_qty = previousofferProductQty - item.qty + decreaseNumber;

        if(rice_product !== 0 && typeFree == 1 && parseInt(check_product_qty) < parseInt(this.state.accountObjective2) && returnProductNumber !== 0){

          this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', common_alert_popup: true, removeFreeProduct: item, freeProductOpen: false,addtoCartTypeQty: decreaseNumber });
            return false;

         }


        if(rice_product == 0 && typeFree == 1 && parseInt(check_product_qty) < parseInt(this.state.accountObjective1) && returnProductNumber !== 0){

          this.setState({common_alert_message: ' If you reduce your cart quantity, it will clear your FREE products.', common_alert_popup: true, removeFreeProduct: item, freeProductOpen: false, addtoCartTypeQty: decreaseNumber });
            return false;
        }


        if(typeFree === 1 && parseInt(previousofferProductQty) == parseInt(this.state.accountObjective1) && returnProductNumber !== 0){

            this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', common_alert_popup: true, removeFreeProduct: item, freeProductOpen: false,addtoCartTypeQty: decreaseNumber });
            return false;

        }else if(typeFree === 1 && rice_product !== 0 && parseInt(previousofferProductQty) == parseInt(this.state.accountObjective2) && returnProductNumber !== 0){

          this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', common_alert_popup: true, removeFreeProduct: item, freeProductOpen:false, addtoCartTypeQty: decreaseNumber});
            return false;

        }

        var cartItemsLast = JSON.parse(localStorage.getItem("cartItems"));
        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;
        var offerProductLastQty = 0;
        var typeFree = 0;

        if(stringSplit !== ''){
          cartItemsLast.map((freeItem)=>{
          stringSplit.filter(function(value) {
            if(freeItem.productNumber === value){
                offerProductLastQty += freeItem.qty;
            }
           })
          });
         }

        cartItemsLast.map((freeItem)=>{

        var increment = this.state.accountObjective1;
        var increment1 = this.state.accountObjective2;

         if(freeItem.product_type === 'Free'){

           typeFree++;

          if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
            increment1 = this.state.accountObjective2;
            productFiveqty = freeItem.qty;
          }else{
            increment = this.state.accountObjective1;
            productFourqty += freeItem.qty;
          }

          totalCount = increment * productFourqty;
          totalCount1 = increment1 * productFiveqty;
          calculatedTotal = totalCount + totalCount1;
          offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
         }

       });

        //console.log(returnProductNumber, freeProductCount, offerproductQtyRemaing);

        if(returnProductNumber !== 0 && freeProductCount > 1 && offerproductQtyRemaing === 0){
           this.setState({decrease_alert_popup: true, decrease_alert_popup_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', decreaseItem: item});
           return false;
        }

        this.setState({ loading: true, reloadCart: false, cartLoader: true });

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === item.productNumber && cartItem.product_type === 'Normal'))) {

            if(item.product_type === 'Normal'){

             newitems = cartItems.map((cartItem) =>

                cartItem.productNumber === item.productNumber && cartItem.product_type === 'Normal'
                    ? {
                        ...cartItem, 
                        qty: cartItem.qty - 1
                    }
                    : cartItem
                
             );

              localStorage.setItem('cartItems', JSON.stringify(newitems));
              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
              this.updateStateValue();
            
            }
        }


        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === item.productNumber && cartItem.product_type === 'Free'))) {

            if(item.product_type === 'Free'){

             newitems = cartItems.map((cartItem) =>

                cartItem.productNumber === item.productNumber && cartItem.product_type === 'Free'
                    ? {
                        ...cartItem, 
                        qty: cartItem.qty - 1
                    }
                    : cartItem
             );

              localStorage.setItem('cartItems', JSON.stringify(newitems));
              this.updateStateValue();
              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
            
            }

        }

        localStorage.setItem('cartItems', JSON.stringify(newitems));
        this.updateStateValue();

        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));
        
        if(cartItemsNew.some((cartItem) => cartItem.product_type === 'Free')) {
            typeFree = 1;
        }

        var offerProductQty = 0;
        var LastRiceProduct = 0;
        var returnProductNumberOld = 0;

        if(stringSplit !== ''){

         stringSplit.filter(function(value) {

          if(value ===  item.productNumber){

                returnProductNumberOld = value;
           }

          });

          cartItemsNew.map((cartItem) => {

            if(cartItem.product_type === 'Free' && this.state.freeProductDataFive.includes(cartItem.productNumber)){
                LastRiceProduct = cartItem.productNumber;
            }

            stringSplit.filter(function(value) {
                if(cartItem.productNumber === value){
                    offerProductQty += cartItem.qty;
                }
            });
         });

        }

        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;

         cartItemsNew.map((freeItem)=>{
            var increment = this.state.accountObjective1;
            var increment1 = this.state.accountObjective2;

           if(freeItem.product_type === 'Free'){

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                increment1 = this.state.accountObjective2;
                productFiveqty = freeItem.qty;
              }else{
                increment = this.state.accountObjective1;
                productFourqty += freeItem.qty;
              }


              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;

              calculatedTotal = totalCount + totalCount1;

              offerproductQtyRemaing = offerProductQty - calculatedTotal;
           }

          });

         if(typeFree === 0){

           offerproductQtyRemaing = offerProductQty;
         }

         localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
         localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

        //console.log(typeFree, item.product_type, offerProductQty, offerproductsList.productQtyToBeAdded);

        if(typeFree == 0 && item.product_type == 'Normal' && parseInt(offerProductQty) <= parseInt(this.state.accountObjective2) && parseInt(this.state.accountObjective1) <= parseInt(offerProductQty)  && returnProductNumberOld !== 0){

            this.setState({checkedItems: new Array(localStorage.getItem("freeProductIds")), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});

        }else if(typeFree == 1 && item.product_type == 'Normal' && parseInt(offerProductQty) <= parseInt(this.state.accountObjective1) && parseInt(this.state.accountObjective1) <= parseInt(offerProductQty) && returnProductNumberOld !== 0){


            this.setState({checkedItems: new Array(localStorage.getItem("freeProductIds")), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});

        } else if(typeFree == 1 && item.product_type == 'Normal' && offerProductQty >= this.state.accountObjective2 && this.state.accountObjective1 <= offerProductQty && LastRiceProduct === ''  && returnProductNumberOld !== 0){

            this.setState({checkedItems: localStorage.getItem("freeProductIds"), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});
        }

        if(offerProductQty !=='' && returnProductNumberOld !== 0){

            this.freeProductQtyUpdateOnly(offerProductQty, 'decrease');
        } 


        if(typeFree == '1' && offerProductQty > this.state.accountObjective2 && returnProductNumberOld !== 0){

            var fourValue = this.state.accountObjective1;
            var fiveValue = this.state.accountObjective2;
            var retunrFour4 = this.checkIfMultiple(offerProductQty, fourValue);
            var retunrFour5 = this.checkIfMultiple(offerProductQty, fiveValue);

        }

        this.setState({ reloadCart: true, loading: false});
    }


    addtoCart(e, item) {

        e.preventDefault();

        this.setState({minmumAmountError: false});

        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;
        //console.log(offerproductsList, 'offerproductsList');
        if(offerproductsList !== '' && offerproductsList !==''){
         productToBeAdded = offerproductsList.productToBeAdded;
        // stringSplit = productToBeAdded.split(',');
        }   

        // Update cart item quantity if already in cart
        var newitems = [];
        var freeProductNumber = '';

        var product_qty = parseInt(document.getElementById("product_number_"+item.productNumber).value);

        var freePopupOpened = 0;
        var offerProductQty_old = 0;
        var previousQty = 0;
        var oldRice = 0;
        var itemCartDetails = [];
        var existFree = '';
        var freeProductCount = 0;
        var returnProductNumberIndex = 0;

        cartItems.map((cartItem) => {

           if(cartItem.product_type === 'Free'){
                    freeProductCount++;
            }

            if(cartItem.productNumber === item.productNumber){
                previousQty = cartItem.qty;
                itemCartDetails = cartItem;
            }

            if(this.state.freeProductDataFive.includes(cartItem.productNumber) === true && cartItem.product_type === 'Free'){

                oldRice = cartItem.productNumber;
                existFree = '1';
            }

            if(cartItem.product_type === 'Free'){
                existFree = '1';
            }

           if(stringSplit !== ''){
            stringSplit.filter(function(value) {
                if(cartItem.productNumber === value){
                    offerProductQty_old += cartItem.qty;
                }
             });
           }

          });


        if(stringSplit !== ''){
            stringSplit.filter(function(value) {
                if(item.productNumber === value){
                    returnProductNumberIndex = value;
                }
             });
        }


        var check_product_qty = offerProductQty_old - previousQty + product_qty;

        ///console.log(oldRice, check_product_qty, existFree, returnProductNumberIndex, freeProductCount);

         if(oldRice !== 0 && parseInt(check_product_qty) < parseInt(this.state.accountObjective2) && returnProductNumberIndex !== 0 && freeProductCount > 0 ){

         /// this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', common_alert_popup: true, removeFreeProduct: itemCartDetails, freeProductOpen:false, delete_item_popup_free: false, delete_item_popup: false, addtoCartTypeQty:product_qty});

           this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', common_alert_popup: true, removeFreeProduct: itemCartDetails, freeProductOpen:false, delete_item_popup_free: false, delete_item_popup: false, addtoCartTypeQty:product_qty});

          return false;

         }

        if(oldRice == 0 && existFree == '1' && parseInt(check_product_qty) < parseInt(this.state.accountObjective1) && returnProductNumberIndex !== 0 && freeProductCount > 0){

         this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products.', common_alert_popup: true, removeFreeProduct: itemCartDetails, freeProductOpen:false, delete_item_popup_free: false, delete_item_popup: false, addtoCartTypeQty:product_qty });

          return false;

        }

        var cartItemsLast = JSON.parse(localStorage.getItem("cartItems"));
        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;
        var offerProductLastQty = 0;
        var typeFree = 0;

        if(stringSplit !== ''){
         cartItemsLast.map((freeItem)=>{
         stringSplit.filter(function(value) {
            if(freeItem.productNumber === value){
                offerProductLastQty += freeItem.qty;
            }
          });
         });
        }

        cartItemsLast.map((freeItem)=>{

        var increment = this.state.accountObjective1;
        var increment1 = this.state.accountObjective2;

         if(freeItem.product_type === 'Free'){

           typeFree++;

          if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
            increment1 = this.state.accountObjective2;
            productFiveqty = freeItem.qty;
          }else{
            increment = this.state.accountObjective1;
            productFourqty += freeItem.qty;
          }

          totalCount = increment * productFourqty;
          totalCount1 = increment1 * productFiveqty;
          calculatedTotal = totalCount + totalCount1;
          offerproductQtyRemaing = offerProductLastQty - calculatedTotal;

         }

        });

        if(returnProductNumberIndex !== 0){

            var old_Value = previousQty;
            var new_Value = product_qty;

            if(new_Value < old_Value){

             var test =  old_Value - new_Value;

             offerproductQtyRemaing = offerproductQtyRemaing - test;

            }
        }

        if(returnProductNumberIndex !== 0 && freeProductCount > 1 && offerproductQtyRemaing < 0){
           this.setState({decrease_alert_popup: true, decrease_alert_popup_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', decreaseItem: item, decrease_alert_qty:product_qty });
           return false;
        }

        this.setState({ loading:false, reloadCart: false, freeProductOpen:false });

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === item.productNumber && cartItem.product_type !== 'Free'))) {

            newitems = cartItems.map((cartItem) =>
                cartItem.productNumber === item.productNumber && cartItem.product_type == 'Normal'
                    ? {
                        ...cartItem,
                        qty: parseInt(document.getElementById("product_number_"+item.productNumber).value)
                    }
                    : cartItem
            )

        } else {

            var offer_product_tag = 'No';

             if(returnProductNumberIndex !== 0){

                offer_product_tag = 'Yes';

             }else{

                offer_product_tag = 'No';
             }

            if (cartItems !== null) {
                newitems = [...cartItems, { ...item, qty: parseInt(document.getElementById("product_number_"+item.productNumber).value), product_type: 'Normal', offer_applicable:offer_product_tag}]
            } else {
                newitems = [{ ...item, qty: parseInt(document.getElementById("product_number_"+item.productNumber).value), product_type: 'Normal', offer_applicable: offer_product_tag}]
            }

        }

        newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
        localStorage.setItem('cartItems', JSON.stringify(newitems));
        this.updateStateValue();

        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));
        var typeFree = 0;
        var freeRice = 0;
       
        if(cartItemsNew.some((cartItem) => cartItem.product_type === 'Free')) {
            typeFree = 1;
        }

        cartItemsNew.map((cartItemFive)=>{

            if(this.state.freeProductDataFive.includes(cartItemFive.productNumber)){

                freeRice = '6587';
            }
        });

        var offerProductQty = 0;
        var returnProductNumber = 0;

        if(stringSplit !== ''){

             stringSplit.filter(function(value) {
              if(value ===  item.productNumber){
                 returnProductNumber = value;
               }
            });

            cartItemsNew.map((cartItem) => {
                stringSplit.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductQty += cartItem.qty;
                    }
                });
            });
        }

        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;

         cartItemsNew.map((freeItem)=>{
            var increment = this.state.accountObjective1;
            var increment1 = this.state.accountObjective2;

           if(freeItem.product_type === 'Free'){

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){

                increment1 = this.state.accountObjective2;
                productFiveqty = freeItem.qty;
              }else{
                increment = this.state.accountObjective1;
                productFourqty += freeItem.qty;
              }

              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;
              calculatedTotal = totalCount + totalCount1;
              offerproductQtyRemaing = offerProductQty - calculatedTotal;
           }

          });

         if(typeFree === 0){

           offerproductQtyRemaing = offerProductQty;
         }

         localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
         localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

         // console.log(offerproductQtyRemaing, 'offerproductQtyRemaing');
         // console.log(typeFree, offerProductQty, this.state.accountObjective1, this.state.freeProductOpen, freeRice, returnProductNumber, offerProductQty_old);

        if(typeFree == '0' &&  parseInt(offerProductQty) >= parseInt(this.state.accountObjective1) && freePopupOpened == '0' && returnProductNumber !== 0){

          this.setState({checkedItems: localStorage.getItem("freeProductIds"), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});

        } else if(typeFree == '1' && parseInt(offerProductQty) >= parseInt(this.state.accountObjective1) && freePopupOpened == '0' && freeRice !== '0' && returnProductNumber !== 0 && offerProductQty_old < this.state.accountObjective2 && offerProductQty >= this.state.accountObjective2){

            this.setState({checkedItems2: localStorage.getItem("freeProductIds"), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});

        }

        // console.log(this.state.freeProductOpen, 'this.state.freeProductOpen');
        // console.log(offerProductQty, 'offerProductQty');
        // console.log(offerProductQty_old, 'offerProductQty_old');

        if(offerProductQty !=='' && returnProductNumber !== 0 && offerProductQty_old >= offerProductQty){

          this.freeProductQtyUpdateOnly(offerProductQty, 'decrease');
        } 


       // console.log(typeFree, offerProductQty, this.state.accountObjective1, returnProductNumber,  offerProductQty, offerProductQty_old, 'offerProductQty');
            
        if(typeFree == 1 && parseInt(offerProductQty) >= parseInt(this.state.accountObjective1) && returnProductNumber != 0){

            var fourValue = this.state.accountObjective1;
            var fiveValue = this.state.accountObjective2;
            var retunrFour4 = this.checkIfMultiple(offerProductQty, fourValue);
            var retunrFour5 = this.checkIfMultiple(offerProductQty, fiveValue);

            if(retunrFour4 === true){

                this.setState({checkedItems2: localStorage.getItem("freeProductIds"), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});

            }

            if(retunrFour5 === true){

                this.setState({checkedItems2: localStorage.getItem("freeProductIds"), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});

            }
        }

        this.setState({ reloadCart: true, loading: false });
    }

    checkIfMultiple(num1, num2) {
      return num1 % num2 === 0;
    }

    freeProductQtyUpdateOnly(offerProductQty){

        var offerproductsList = this.state.offerCombineProducts;
        var offerProductQty = offerProductQty;
        var divided_by_4 = offerProductQty / parseInt(this.state.accountObjective1);
        var divided_by_5 = offerProductQty / parseInt(this.state.accountObjective2);
        var firstNum4 = parseInt(divided_by_4);
        var firstNum5 = parseInt(divided_by_5);

        var cartItems = JSON.parse(localStorage.getItem("cartItems"));

        var newitems = [];

        var freeProductCount = 0;

        cartItems.map((cartItem)=>{
            if(cartItem.product_type === 'Free'){
                freeProductCount++;
            }
        });

        if(freeProductCount === 1){

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.product_type == 'Free' && 
            this.state.freeProductDataFive.includes(cartItem.productNumber) ))) {

            var previousQtyFive = 0;

             cartItems.map((cartItem) =>{
                if(cartItem.product_type === 'Free'){
                    previousQtyFive = cartItem.qty;
                }
             });

             if(previousQtyFive  > firstNum5){

               newitems = cartItems.map((cartItem) =>
                this.state.freeProductDataFive.includes(cartItem.productNumber) && cartItem.product_type === 'Free'
                    ? {
                        ...cartItem, 
                        qty:  firstNum5
                    }
                    : cartItem
                );

              localStorage.setItem('cartItems', JSON.stringify(newitems));
              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
              localStorage.setItem('cartItems', JSON.stringify(newitems));
              this.updateStateValue();
              this.setState({freeProductQty: firstNum5});
             }
        }

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.product_type == 'Free' && this.state.freeProductDataFive.includes(cartItem.productNumber) !== true ))) {

            var previousQty = 0;

             cartItems.map((cartItem) =>{

                if(cartItem.product_type === 'Free'){

                   
                    previousQty = cartItem.qty;

                }

             });

             if(previousQty  > firstNum4){

             newitems = cartItems.map((cartItem) =>

                 cartItem.product_type === 'Free'
                    ? {
                        ...cartItem, 
                        qty:  firstNum4
                    }
                    : cartItem
                
              );


              localStorage.setItem('cartItems', JSON.stringify(newitems));
              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
              localStorage.setItem('cartItems', JSON.stringify(newitems));
              this.updateStateValue();
              this.setState({freeProductQty: firstNum4});

             }

        }

        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;

        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));

         cartItemsNew.map((freeItem)=>{
            var increment = this.state.accountObjective1;
            var increment1 = this.state.accountObjective2;

           if(freeItem.product_type === 'Free'){

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                increment1 = this.state.accountObjective2;
                productFiveqty = freeItem.qty;
              }else{
                increment = this.state.accountObjective1;
                productFourqty += freeItem.qty;
              }

              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;
              calculatedTotal = totalCount + totalCount1;

              offerproductQtyRemaing = offerProductQty - calculatedTotal;
           }

          });

         localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
         localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

       }

    }

    freeProductQtyUpdate(offerProductQty, type){

        var freeProductList = this.state.freeProductData;
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;
        if(offerproductsList !== ''){
         productToBeAdded = offerproductsList.productToBeAdded;
         //stringSplit = productToBeAdded.split(',');
        }

        var offerProductQty = offerProductQty;
        var divided_by_4 = offerProductQty / this.state.accountObjective1;
        var divided_by_5 = offerProductQty / this.state.accountObjective2;
        var firstNum4 = parseInt(divided_by_4);
        var firstNum5 = parseInt(divided_by_5);

        var cartItems = JSON.parse(localStorage.getItem("cartItems"));

        var newitems = [];

        var freeProductCount = 0;

        cartItems.map((cartItem)=>{
            if(cartItem.product_type === 'Free'){
                freeProductCount++;
            }
        });

        if(freeProductCount === 1){

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.product_type == 'Free' && 
            this.state.freeProductDataFive.includes(cartItem.productNumber) ))) {

             newitems = cartItems.map((cartItem) =>

                this.state.freeProductDataFive.includes(cartItem.productNumber) && cartItem.product_type === 'Free'
                    ? {
                        ...cartItem, 
                        qty:  firstNum5
                    }
                    : cartItem
                
             );

              localStorage.setItem('cartItems', JSON.stringify(newitems));
              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
              localStorage.setItem('cartItems', JSON.stringify(newitems));
              this.updateStateValue();
              this.setState({freeProductQty: firstNum5});
        }

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.product_type == 'Free' && this.state.freeProductDataFive.includes(cartItem.productNumber) !== true ))) {

             newitems = cartItems.map((cartItem) =>

                 cartItem.product_type === 'Free'
                    ? {
                        ...cartItem, 
                        qty:  firstNum4
                    }
                    : cartItem
                
             );

              localStorage.setItem('cartItems', JSON.stringify(newitems));
              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
              localStorage.setItem('cartItems', JSON.stringify(newitems));
              this.updateStateValue();
              this.setState({freeProductQty: firstNum4});
        }

       }else{

        var newitemsLast = [];
        newitemsLast = cartItems.filter((cartItem) => (cartItem.product_type !== 'Free'));
        localStorage.setItem('cartItems', JSON.stringify(newitemsLast));

        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;
        var offerProductLastQty = 0;
        var typeFree = 0;
        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));

        if(stringSplit !== ''){
            cartItemsNew.map((cartItem) => {
                stringSplit.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductLastQty += cartItem.qty;
                    }
                })
             });
        }


       // console.log(offerProductLastQty, 'offerProductLastQty');

         cartItemsNew.map((freeItem)=>{
            var increment = this.state.accountObjective1;
            var increment1 = this.state.accountObjective2;

           if(freeItem.product_type === 'Free'){

               typeFree++;

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                increment1 = this.state.accountObjective2;
                productFiveqty = freeItem.qty;
              }else{
                increment = this.state.accountObjective1;
                productFourqty += freeItem.qty;
              }


              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;

              calculatedTotal = totalCount + totalCount1;

              offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
           }

          });


         if(typeFree === 0){

           offerproductQtyRemaing = offerProductLastQty;
         }

        localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
        localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

        if(offerproductQtyRemaing > 0){
        this.setState({freeProductOpen:true, offerProductQty:offerProductLastQty, offerproductQtyRemaing: offerproductQtyRemaing});
         }

       }

    }

    CloseFreePopup=()=> {
        this.setState({freeProductOpen:false, freeProductListOpen: false});
    }


    addFreeProduct(event,checkedprod,freeProduct, productValue, freeProductNew, checkedState){

       event.preventDefault();
       document.getElementById("alert_message").innerHTML = '';
       
       if(checkedprod.length > 0){
        this.setState({checkedItems:checkedprod});
       }

       var condition = 0;
       var inputCount = 0;

        productValue.map((value, index)=>{
           inputCount += value.qty;
        });

       if(inputCount > 0){

        var freeProductList = freeProduct;
        var newitems_new = [];
        var cartItemsList = JSON.parse(localStorage.getItem("cartItems"));
        var freeItems = [];

        freeProductList.data.map((data, index)=>{

            var oldprice = '';
            var productDescriptionText = '';

            var newitems = [];

            var current = this;

            this.updateStateValue();

            var freeQty = 0;
            if(condition === 0){

               var cartItems = JSON.parse(localStorage.getItem("cartItems"));
                   oldprice = data.PDP_Price1;
                   productDescriptionText = data.productDescription;
                   data.PDP_Price1 = '0';
                   data.productDescription = productDescriptionText;

             if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === data.productNumber && cartItem.product_type === 'Free'))) {

                productValue.map((freeItem)=>{
                    if(freeItem.pid === data.productNumber){
                        freeQty = freeItem.qty;
                        freeItems.push(freeItem.pid);
                    }
                });

                newitems = cartItems.map((cartItem) =>
                    cartItem.productNumber === data.productNumber && cartItem.product_type === 'Free'
                        ? {
                            ...cartItem,
                            qty: freeQty
                        }
                        : cartItem
                )

                 localStorage.setItem('cartItems', JSON.stringify(newitems));
                 this.updateStateValue();

               } else {

                productValue.map((freeItem)=>{
                    if(freeItem.pid === data.productNumber){
                        freeQty = freeItem.qty;
                        freeItems.push(freeItem.pid);
                    }
                });


                if (cartItems !== null) {

                    newitems = [...cartItems, { ...data, qty: freeQty, product_type: 'Free', offer_applicable: 'No' }]
                } else {

                    newitems = [{ ...data, qty: freeQty, product_type: 'Free', offer_applicable: 'No' }]
                }

              }
 
            newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
            localStorage.setItem('cartItems', JSON.stringify(newitems));
            this.updateStateValue();
            data.PDP_Price1 = oldprice;
            data.productDescription = productDescriptionText;
            localStorage.setItem('freeProductIds', data.productNumber);
            this.setState({ viewFreeProductInfo: '', freeProductOpen:false,freeProductIds: (this.state[data.productNumber] > 0 ? '' :  data.productNumber)});

          }

        });


        localStorage.setItem('freeProductIdsNew', freeItems);

        this.setState({ freeProductIds: freeItems});

        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;

        if(offerproductsList !== '' && offerproductsList !==''){
           productToBeAdded = offerproductsList.productToBeAdded;
           //stringSplit = productToBeAdded.split(',');
        } 

        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));
        var offerProductQty = 0;

        if(stringSplit !== ''){
            cartItemsNew.map((cartItem) => {
                stringSplit.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductQty += cartItem.qty;
                    }
                });
             });   
        }

       }else{
        document.getElementById("alert_message").innerHTML = 'Please select the minimum one item';
       }
    }

    offerProduct(){
    

     var loginDetails = {};
     if (localStorage.getItem('authData')) {
        loginDetails = JSON.parse(localStorage.getItem('authData'));
     }

     let URL = BaseUrl + "offerlist";
     axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {

        //console.log(response, 'response');
        
        let responseList = response.data.data;

        responseList.sort((a,b) => Number(a.freeProductQtyToAdd) - Number(b.freeProductQtyToAdd));

        let responseData = responseList[0];

        if(response.data.data.length > 0 && response.data.data.length == '1'){

        let responseDataFour = responseList[0];
        var list1 = responseDataFour.freeProductToAdd;
            list1 = list1.split(',');

        var combineArray = list1;
        var offerlist1 = responseDataFour.productToBeAdded;
            offerlist1 = offerlist1.split(',');
        var combineOfferArray = offerlist1;  

        var duplicateArrayRemove = combineArray.filter((item,
        index) => combineArray.indexOf(item) === index);

        var duplicateArrayRemoveOffer = combineOfferArray.filter((item,
        index) => combineOfferArray.indexOf(item) === index);

        this.setState({ offerproducts: responseDataFour, offerCombineProducts: duplicateArrayRemoveOffer, offerCombineFreeProducts: duplicateArrayRemove, freeProductDataFour: list1, freeProductDataFive: []}, function(){
            this.offerProductData(duplicateArrayRemoveOffer);
            this.getFreeProductList(responseDataFour, duplicateArrayRemove);
            this.checkOfferProductCount(responseDataFour, duplicateArrayRemoveOffer);
        });

     }else{

        let responseDataFour = responseList[0];
        let responseDataFive = responseList[1];
        var combineArray = [];

        var list1 = responseDataFour.freeProductToAdd;
            list1 = list1.split(',');

        var list2 = responseDataFive.freeProductToAdd;
            list2 = list2.split(',');

         combineArray = list1.concat(list2);

        var offerlist1 = responseDataFour.productToBeAdded;
            offerlist1 = offerlist1.split(',');
        var offerlist2 = responseDataFive.productToBeAdded;
            offerlist2 = offerlist2.split(',');
        var combineOfferArray = offerlist1.concat(offerlist2);  


        var duplicateArrayRemove = combineArray.filter((item,
        index) => combineArray.indexOf(item) === index);

        var duplicateArrayRemoveOffer = combineOfferArray.filter((item,
        index) => combineOfferArray.indexOf(item) === index);

        this.setState({ offerproducts: responseData, offerCombineProducts: duplicateArrayRemoveOffer, offerCombineFreeProducts: duplicateArrayRemove, freeProductDataFour: list1, freeProductDataFive: list2}, function(){
            this.offerProductData(duplicateArrayRemoveOffer);
            this.getFreeProductList(responseData, duplicateArrayRemove);
            this.checkOfferProductCount(responseData, duplicateArrayRemoveOffer);
        });
     }


     }).catch((err) => {
        console.log(err);
     });

    }


    offerProductData(responseData){

        var offerproductsList = responseData;
        this.setState({ loading: true });
        let authData = { accountPriceListId: "" };
        authData = JSON.parse(localStorage.getItem('authData'));
        let productsId = { "$in": offerproductsList };
        let payload = {
            productIds: productsId,
            priceband: localStorage.getItem('priceband')
        }

        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

        let URL = BaseUrl + "productsbyids";
        axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
            let responseData = response.data.data;
            this.setState({ offerProductData: responseData, loading: false});
        }).catch((err) => {
            console.log(err);
            this.setState({ loading: false })
        });
    }

    getFreeProductList(responseData, duplicateArrayRemove){

        var offerproductsList = responseData;

        if(offerproductsList !==''){

        // var freeProductToAdd = offerproductsList.freeProductToAdd;
        // var stringFreeSplit = freeProductToAdd.split(',');

        let productsId = { "$in": duplicateArrayRemove };

        let payload = {
            productIds: productsId,
            //priceband: localStorage.getItem('priceband')
        }

       
        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        } let URL = BaseUrl + "freeproductsbyids";

        axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {


         this.setState({freeProductData: response.data});
        }).catch((err) => {
        });

      }

    }

    getProductCategories() {
        this.setState({ loading: true });
        const id = window.location.pathname.split('/').pop();
        let categoryId = {};
        let pageTitle = "";
        if (id === "pizza") {
            categoryId = { "$in": ["1"] };
            pageTitle = "PIZZA"
        }
        else if (id === "pasta-rice-noodle-sauces") {
            categoryId = { "$in": ["10", "13"] };
            pageTitle = "PASTA, RICE & NOODLE SAUCES"
        }
        else if (id === "burrito") {
            categoryId = { "$in": ["11", "12"] };
            pageTitle = "BURRITO"
        }

        setTimeout(() => {
            this.setState({ pageTitle: pageTitle })
        }, 1000);

        let authData = { accountPriceListId: "" };
        authData = JSON.parse(localStorage.getItem('authData'));
        let payload = {
            category: categoryId,
            priceband: localStorage.getItem('priceband')
        }
      
        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }
        
        let URL = BaseUrl + "products";
        axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {

            let responseData = response.data.data;
            let duplicateResponse = response.data.data;

            duplicateResponse.sort(this.dynamicSort("ProductGroup"));

            var filterList = [];

            duplicateResponse.map((item) =>{

                if(item.SuitableFor !== '' && item.SuitableFor !== null ){

                    filterList.push(item.SuitableFor);
                }
            });

            var duplicateFilterRemove = filterList.filter((item,
             index) => filterList.indexOf(item) === index);

            var productGroupList = [];

            duplicateResponse.map((item) =>{

                if(item.ProductGroup !== '' && item.ProductGroup !== null ){

                    productGroupList.push(item.ProductGroup);
                }
            });

            var duplicateGroupRemove = productGroupList.filter((item,
             index) => productGroupList.indexOf(item) === index);

             let groupProductsList = [];

              duplicateGroupRemove.map((item) => {

                    let productGroup = [];
                    duplicateResponse.map((product) => {

                        if (item == product.ProductGroup){
                            productGroup.push(product);
                        }

                    });

                    if(productGroup.length > 0){
                       groupProductsList.push({ [item]: productGroup }); 
                    }

                });

            ///console.log(groupProductsList, 'groupProductsList');

            this.setState({ products: duplicateResponse, filterValueList:  duplicateFilterRemove, tempproducts: duplicateResponse, groupProductsList: groupProductsList, groupFilterList: duplicateGroupRemove});
            this.setState({ loading: false });
            this.updateStateValue();


        }).catch((err) => {
            console.log(err);
            this.setState({ loading: false })
        });
    }


         getProductCategoriesNew() {

            let groupProductsList = this.state.groupProductsList;

            this.setState({ groupProductsList, groupProductsList});


          }


       dynamicSort(property) {
        var sortOrder = 1;

        if(property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }

        return function (a,b) {
            if(sortOrder == -1 && b[property] !== null){
                return b[property].localeCompare(a[property]);
            }else if(a[property] !== null){
                return a[property].localeCompare(b[property]);
            }        
         }
       }



    priceFormat(price) {
        return price.toLocaleString("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2
        });
    }

    expandCart() {
        var cartTable = document.querySelector('.cart-side-table');
        cartTable.classList.toggle("open");
    }


    deleteSingleItem(e, item){

      this.setState({freeProductOpen:false, minmumAmountError: false});

        if(item.product_type !== 'Free'){

            var cartItems = JSON.parse(localStorage.getItem("cartItems"));

            var newitems = [];
            var offerproductsList = this.state.offerproducts;
            var productToBeAdded = '';
            var stringSplit = this.state.offerCombineProducts;
            if(offerproductsList !== '' && offerproductsList !==''){
             productToBeAdded = offerproductsList.productToBeAdded;
             //stringSplit = productToBeAdded.split(',');
            }

            var typeFree = 0;
            var rice_product = 0;
            var existFree = '';

            if(cartItems.some((cartItem) => cartItem.product_type == 'Free')) {
                typeFree = 1;
            }

            var previousofferProductQty = 0;
            var returnProductNumber = 0;
            var previousQty = 0;
            var oldRice = '';
            var freeProductCount = 0;
            var freeProductQtyCount = 0;

            if(stringSplit !== ''){

            cartItems.map((cartItem) => {

              if(cartItem.productNumber === item.productNumber){
                 previousQty = cartItem.qty;
               }

              if(cartItem.product_type === 'Free'){
                existFree = '1';
                freeProductCount++;
                freeProductQtyCount += cartItem.qty;
              }

              if(this.state.freeProductDataFive.includes(cartItem.productNumber) === true && cartItem.product_type == 'Free'){

                rice_product = '6587';
              }

              stringSplit.filter(function(value) {
                   if(value ===  item.productNumber){
                    returnProductNumber = value;
                   }

                  if(value === cartItem.productNumber && cartItem.product_type !== 'Free'){
                    previousofferProductQty += cartItem.qty;
                  }
                });
              });
             }

             var check_product_qty = previousofferProductQty - previousQty;

    
              var CheckFreeProductDelete = this.checkProductDelete(item);

               console.log(returnProductNumber, freeProductCount,CheckFreeProductDelete, freeProductQtyCount, 'cart-prod-delete');

               if(returnProductNumber !== 0 && freeProductQtyCount == 1 && freeProductCount == 1 && CheckFreeProductDelete == 0){
                   this.setState({delete_item_alert_popup: true, delete_single_Item: item, delete_item_alert_message: 'If you reduce your cart quantity, it will clear your FREE products.'});
                   return false;
                }

                if(returnProductNumber !== 0 && freeProductCount == 1 && CheckFreeProductDelete == 0){
                   this.setState({delete_item_alert_popup: true, delete_single_Item: item, delete_item_alert_message: 'Are you sure you want to delete this item?'});
                   return false;
                }


                if(returnProductNumber !== 0 && freeProductCount == 0 && CheckFreeProductDelete == 0){
                   this.setState({delete_item_alert_popup: true, delete_single_Item: item, delete_item_alert_message: 'Are you sure you want to delete this item?'});
                   return false;
                }


                if(returnProductNumber !== 0 && freeProductCount > 1 && CheckFreeProductDelete == 0){
                   this.setState({delete_item_alert_popup: true, delete_single_Item: item, delete_item_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.'});
                   return false;
                }


               if(rice_product !== 0 && check_product_qty < this.state.accountObjective2 && returnProductNumber !== 0){

                 this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', common_alert_popup: true, removeFreeProduct: item, freeProductOpen:false, delete_item_popup_free: false, delete_item_popup: false, addtoCartTypeQty:0});

                  return false;
                
               }


             if(typeFree == 1 && rice_product == 0 && check_product_qty < this.state.accountObjective1 && returnProductNumber !== 0){

                 this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', common_alert_popup: true, removeFreeProduct: item, freeProductOpen:false, delete_item_popup_free: false, delete_item_popup: false, addtoCartTypeQty:0});
                 
                  return false;
                
               }

             //console.log(typeFree, previousofferProductQty, this.state.accountObjective1, this.state.accountObjective2, rice_product,  returnProductNumber, 'currentDateFormat');

             if(typeFree == 1 && previousofferProductQty == this.state.accountObjective1 && returnProductNumber !== 0){
              this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', delete_item_popup_free: true, delete_item_popup_free_message: 'If you reduce your cart quantity, which will remove your free product?',removeProduct: item, freeProductOpen:false});
              return false;

             }else if(typeFree == 1 && rice_product !== 0 && previousofferProductQty == this.state.accountObjective2 && returnProductNumber !== 0){

              this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', delete_item_popup_free: true, delete_item_popup_free_message: 'If you reduce your cart quantity, which will remove your free product?', removeProduct: item, freeProductOpen:false });
                return false;

             }else{

               if(returnProductNumber !== 0){

               this.setState({common_alert_popup: false, delete_item_popup_free:false, clear_cart: false, delete_item_popup: true, removeProduct: item, freeProductOpen:false});
               return false;

              }else{

               this.setState({common_alert_popup: false, delete_item_popup_free:false, clear_cart: false, delete_item_popup: true, removeProduct: item, freeProductOpen:false});
                return false;
              }

             }

    
            } else{

            this.setState({common_alert_message: 'Are you sure you want to delete your free product?', common_alert_popup: true, removeFreeProduct: item, clear_cart: false, delete_item_popup: false, delete_item_popup_free:false, freeProductOpen:false});

            return false;
           }

     }


     checkProductDeleteNew(item, qty){

        var cartItemsLast = JSON.parse(localStorage.getItem("cartItems"));
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;
        if(offerproductsList !== ''){
             productToBeAdded = offerproductsList.productToBeAdded;
            //stringSplit = productToBeAdded.split(',');
        }
        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;
        var offerProductLastQty = 0;
        var typeFree = 0;

        var removeProduct = this.state.removeProduct;

        if(offerproductsList !== ''){
         
         cartItemsLast.map((freeItem)=>{

         stringSplit.filter(function(value) {
            if(freeItem.productNumber === value){
                offerProductLastQty += freeItem.qty;
            }
          });

         });

        }

        // console.log(this.state.freeProductDataFive, 'freeProductDataFive');

        cartItemsLast.map((freeItem)=>{

        var increment = this.state.accountObjective1;
        var increment1 = this.state.accountObjective2;

         if(freeItem.product_type === 'Free'){

           typeFree++;

          if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
            increment1 = this.state.accountObjective2;
            productFiveqty = freeItem.qty;
          }else{
            increment = this.state.accountObjective1;
            productFourqty += freeItem.qty;
          }

          totalCount = increment * productFourqty;
          totalCount1 = increment1 * productFiveqty;
          calculatedTotal = totalCount + totalCount1;

          console.log(calculatedTotal, 'calculatedTotal');

          offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
         }

       });

       console.log(offerproductQtyRemaing, 'instructions');
       console.log(offerProductLastQty, 'offerProductLastQty');
       console.log(qty, 'item.qty');

        if(offerproductQtyRemaing > 0){
            var remaingQty = offerproductQtyRemaing;
            var checkRemaing = offerProductLastQty - qty;    

            console.log(checkRemaing, 'checkRemaing');

            if(checkRemaing >= calculatedTotal){
                return checkRemaing;
            }else{
                return 0;
            }

        }else{
            return 0;
        }
    
     }

     checkProductDelete(item){

        var cartItemsLast = JSON.parse(localStorage.getItem("cartItems"));
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;
        if(offerproductsList !== ''){
             productToBeAdded = offerproductsList.productToBeAdded;
            //stringSplit = productToBeAdded.split(',');
        }
        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;
        var offerProductLastQty = 0;
        var typeFree = 0;

        var removeProduct = this.state.removeProduct;

        if(offerproductsList !== ''){
         
         cartItemsLast.map((freeItem)=>{

         stringSplit.filter(function(value) {
            if(freeItem.productNumber === value){
                offerProductLastQty += freeItem.qty;
            }
          });

         });

        }

        // console.log(this.state.freeProductDataFive, 'freeProductDataFive');

        cartItemsLast.map((freeItem)=>{

        var increment = this.state.accountObjective1;
        var increment1 = this.state.accountObjective2;

         if(freeItem.product_type === 'Free'){

           typeFree++;

          if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
            increment1 = this.state.accountObjective2;
            productFiveqty = freeItem.qty;
          }else{
            increment = this.state.accountObjective1;
            productFourqty += freeItem.qty;
          }

          totalCount = increment * productFourqty;
          totalCount1 = increment1 * productFiveqty;
          calculatedTotal = totalCount + totalCount1;

          console.log(calculatedTotal, 'calculatedTotal');

          offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
         }

       });

       console.log(offerproductQtyRemaing, 'instructions');
       console.log(offerProductLastQty, 'offerProductLastQty');
       console.log(item.qty, 'item.qty');

        if(offerproductQtyRemaing > 0){
            var remaingQty = offerproductQtyRemaing;
            var checkRemaing = offerProductLastQty - item.qty;    

            console.log(checkRemaing, 'checkRemaing');

            if(checkRemaing >= calculatedTotal){
                return checkRemaing;
            }else{
                return 0;
            }

        }else{
            return 0;
        }
    
     }

     clearSingleItem(){

        var freeProductList = this.state.freeProductData;
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;
        if(offerproductsList !== '' && offerproductsList !==''){
         productToBeAdded = offerproductsList.productToBeAdded;
         //stringSplit = productToBeAdded.split(',');
        }
        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var newitems = [];
    
        var freeProductExist = '0';
        var offerProductQty = 0;
        var freeProductCount = 0;
        cartItems.map((cartItem) =>{
         if(cartItem.product_type === 'Free'){
             freeProductExist++;
            }
         });

         var returnProductNumberNew = 0;
         var current = this;
         if(stringSplit !== ''){
         stringSplit.filter(function(value) {
           if(current.state.removeProduct.productNumber === value){
                returnProductNumberNew = value;
            }
         });
        }
        
        var checkFreeItems = JSON.parse(localStorage.getItem("cartItems"));
        var offerProductQty = 0;

        if(stringSplit !== ''){
          checkFreeItems.map((cartItem) => {
            if(cartItem.product_type === 'Free'){
              freeProductCount++;
            }
            stringSplit.filter(function(value) {
                if(cartItem.productNumber === value){
                    offerProductQty += cartItem.qty;
                }
            })
         });
        }

        var localCart = [];

        // console.log('this.state.removeProduct.productNumber', this.state.removeProduct.productNumber);
        // console.log('this.state.removeProduct.product_type', this.state.removeProduct.product_type);
             
        if (cartItems !== null && cartItems.some((cartItem) => cartItem.productNumber == this.state.removeProduct.productNumber && this.state.decreaseDelete === false)) {

            var duplicateProduct = 0;
    
            localCart = cartItems.map((cartItem) =>

                cartItem.productNumber == this.state.removeProduct.productNumber && cartItem.product_type == this.state.removeProduct.product_type
                    ? {
                        ...cartItem, 
                        qty: 0,
                    }
                    : cartItem
                
                );

              localStorage.setItem('cartItems', JSON.stringify(localCart));
              this.updateStateValue();
              localCart = localCart.filter((cartItem) => cartItem.qty >= 1);

              // newitems = cartItems.filter((cartItem) => (cartItem.productNumber !==   this.state.removeProduct.productNumber));

             this.setState({ [this.state.removeProduct.productNumber]: 0, clear_cart: false, delete_item_popup: false});
          }


         if (cartItems !== null && cartItems.some((cartItem) => cartItem.productNumber == this.state.removeProduct.productNumber && this.state.decreaseDelete === true)) {

            var duplicateProduct = 0;
    
            localCart = cartItems.map((cartItem) =>

                cartItem.productNumber == this.state.removeProduct.productNumber
                    ? {
                        ...cartItem, 
                        qty: 0,
                    }
                    : cartItem
                
                );

              localStorage.setItem('cartItems', JSON.stringify(localCart));
              this.updateStateValue();
              localCart = localCart.filter((cartItem) => cartItem.qty >= 1);

              // newitems = cartItems.filter((cartItem) => (cartItem.productNumber !==   this.state.removeProduct.productNumber));

             this.setState({ [this.state.removeProduct.productNumber]: 0, clear_cart: false, delete_item_popup: false, decreaseDelete:false});
          }

          
            localStorage.setItem('cartItems', JSON.stringify(localCart));
            this.updateStateValue();

            this.setState({common_alert_popup: false,  clear_cart: false, delete_item_popup: false, removeProduct: [],delete_item_popup_free: false, freeProductOpen:false, freeProductOpen:false});

          var cartItemsFinal = JSON.parse(localStorage.getItem("cartItems"));
          var offerProductLastQty = 0;
          var freeProductExistLast = '';
          var LastRiceProduct = 0;

          if(stringSplit !== ''){
            cartItemsFinal.map((cartItem) => {
                if(cartItem.product_type === 'Free'){
                    freeProductExistLast++;
                }

                if(cartItem.product_type === 'Free' && this.state.freeProductDataFive.includes(cartItem.productNumber)){

                    LastRiceProduct = cartItem.productNumber;
                }

                stringSplit.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductLastQty += cartItem.qty;
                    }
                });
            });
          }

          //console.log(freeProductExistLast, offerProductLastQty, offerproductsList.productQtyToBeAdded,offerProductLastQty, returnProductNumberNew);

         if(freeProductExistLast === '' && offerProductLastQty <= this.state.accountObjective1 && this.state.accountObjective1 <= offerProductLastQty && returnProductNumberNew !== 0){

            this.setState({common_alert_popup: false,  clear_cart: false, delete_item_popup: false, removeProduct: [],delete_item_popup_free: false, freeProductOpen:true, checkedItems: new Array(localStorage.getItem("freeProductIds")), offerProductQty: offerProductLastQty});

         }else if(freeProductExistLast === '' && offerProductLastQty <= this.state.accountObjective2 && this.state.accountObjective1 <= offerProductLastQty && returnProductNumberNew !== 0){

            this.setState({common_alert_popup: false,  clear_cart: false, delete_item_popup: false, removeProduct: [],delete_item_popup_free: false, freeProductOpen:true, checkedItems: new Array(localStorage.getItem("freeProductIds")), offerProductQty: offerProductLastQty});

         }else if(freeProductExistLast !== '' && LastRiceProduct == '0' && offerProductLastQty <= this.state.accountObjective2 && this.state.accountObjective1 <= offerProductLastQty && returnProductNumberNew !== 0){

            this.setState({common_alert_popup: false,  clear_cart: false, delete_item_popup: false, removeProduct: [],delete_item_popup_free: false, freeProductOpen:true, checkedItems: new Array(localStorage.getItem("freeProductIds")), offerProductQty: offerProductLastQty});

         }else if(offerProductLastQty <= this.state.accountObjective1 && this.state.accountObjective1 <= offerProductLastQty && returnProductNumberNew !== 0){

            this.setState({common_alert_popup: false,  clear_cart: false, delete_item_popup: false, removeProduct: [],delete_item_popup_free: false, freeProductOpen:true, checkedItems: new Array(localStorage.getItem("freeProductIds")), offerProductQty: offerProductLastQty});

        }

        if(offerProductLastQty !=='' && returnProductNumberNew !== 0){
         
         this.freeProductQtyUpdateOnly(offerProductLastQty, 'decrease');
        }

     }


    clearSingleItemFree(){

        this.setState({freeProductOpen:false});

        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var freeProductList = this.state.freeProductData;
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;
        if(offerproductsList !== '' && offerproductsList !==''){
         productToBeAdded = offerproductsList.productToBeAdded;
         //stringSplit = productToBeAdded.split(',');
        }

        var newitems = [];
        var freeProductExist = '0';
        var offerProductQty = 0;
        cartItems.map((cartItem) =>{
         if(cartItem.product_type === 'Free'){
             freeProductExist++;
            }
         });

       var checkFreeItems = JSON.parse(localStorage.getItem("cartItems"));
       var offerProductQty = 0;

       if(stringSplit !== ''){
          checkFreeItems.map((cartItem) => {
            stringSplit.filter(function(value) {
                if(cartItem.productNumber === value){
                    offerProductQty += cartItem.qty;
                }
            })
         });
        }

        var returnProductNumberNew = 0;
        var current = this;

        if(stringSplit !== ''){
          stringSplit.filter(function(value) {
                if(current.state.removeProduct.productNumber === value){
                    returnProductNumberNew = value;
                }
          });
        }

        if(freeProductExist === 1 && offerProductQty == this.state.accountObjective1){

           freeProductList.data.map((data, index)=>{

           if(checkFreeItems !== null && checkFreeItems.some((cartItem) => cartItem.productNumber === data.productNumber)) {

                newitems = checkFreeItems.filter((cartItem) => (cartItem.product_type !== 'Free'));
                localStorage.setItem('cartItems', JSON.stringify(newitems));
             }

         });

         this.updateStateValue();


        }else if(freeProductExist === 1 && offerProductQty == this.state.accountObjective2){

            freeProductList.data.map((data, index)=>{

              if (checkFreeItems !== null && checkFreeItems.some((cartItem) => cartItem.productNumber === data.productNumber)) {

                 newitems = checkFreeItems.filter((cartItem) => (cartItem.product_type !== 'Free' &&  this.state.freeProductDataFive.includes(cartItem.productNumber)));

                localStorage.setItem('cartItems', JSON.stringify(newitems));

              }

            });

        }

        var newitems_last = [];

        var cartItemsLatest = JSON.parse(localStorage.getItem("cartItems"));

        if (cartItemsLatest !== null && cartItemsLatest.some((cartItem) => cartItem.productNumber == this.state.removeProduct.productNumber)) {

            newitems_last = cartItemsLatest.filter((cartItem) => (cartItem.productNumber !== this.state.removeProduct.productNumber && cartItem.product_type !=='Free'));

            this.setState({ [this.state.removeProduct.productNumber]: 0, clear_cart: false, delete_item_popup: false});
        }

        localStorage.setItem('cartItems', JSON.stringify(newitems_last));

        this.updateStateValue();
        this.setState({common_alert_popup: false,  clear_cart: false, delete_item_popup: false, removeProduct: [], delete_item_popup_free: false, freeProductOpen:false});

        var cartItemsFinal = JSON.parse(localStorage.getItem("cartItems"));
        var offerProductLastQty = 0;

        if(stringSplit !== ''){
            cartItemsFinal.map((cartItem) => {
                stringSplit.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductLastQty += cartItem.qty;
                    }
                })
             });
        }


        if(offerProductLastQty >= this.state.accountObjective1 && returnProductNumberNew !== 0){

         this.setState({checkedItems: localStorage.getItem("freeProductIds"), freeProductOpen:true, offerProductQty: offerProductLastQty});
       }

        if(offerProductLastQty !=='' && returnProductNumberNew !== 0){

            this.freeProductQtyUpdate(offerProductLastQty, 'clear');
            
        }
    }

    freeProductPopupOpen(e){

        e.preventDefault();

        this.setState({minmumAmountError: false});

        var cartItemsFinal = JSON.parse(localStorage.getItem("cartItems"));
        var offerProductLastQty = 0;
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;

        if(offerproductsList !== '' && offerproductsList !==''){
         productToBeAdded = offerproductsList.productToBeAdded;
         //stringSplit = productToBeAdded.split(',');
        }
        
        if(stringSplit !== ''){
            cartItemsFinal.map((cartItem) => {
                stringSplit.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductLastQty += cartItem.qty;
                    }
                })
             });
        }

        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));
        var typeFree = 0;

        if(cartItemsNew.some((cartItem) => cartItem.product_type === 'Free')) {
            typeFree = 1;
        }

        let prodlist = this.state.freeProductData.data.map(prd=>{return ({pid:prd.productNumber,qty:0})});

        var offerproductQtyRemaing = 0;

        var productFourqty  = 0;
        var productFiveqty  = 0;

        var totalCount = 0;
        var totalCount1 = 0;

        var calculatedTotal = 0;


         cartItemsNew.map((freeItem)=>{
            var increment = this.state.accountObjective1;
            var increment1 = this.state.accountObjective2;

           if(freeItem.product_type === 'Free'){

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                increment1 = this.state.accountObjective2;
                productFiveqty = freeItem.qty;
              }else{
                increment = this.state.accountObjective1;
                productFourqty += freeItem.qty;
              }


              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;

              calculatedTotal = totalCount + totalCount1;

              offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
           }

          });

         if(typeFree === 0){
           offerproductQtyRemaing = offerProductLastQty;
         }

        localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
        localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

        this.setState({freeProductOpen:true, offerProductQty:offerProductLastQty, productValueIndex: prodlist, offerproductQtyRemaing: offerproductQtyRemaing});
    }


   freeProductQtyFour(productQty, item){
    
        var divided_by_4 = productQty / this.state.accountObjective1;
        var firstNum4 = parseInt(divided_by_4);
        return firstNum4;
    }


   freeProductQtyFive(productQty, item){

        var divided_by_4 = productQty / this.state.accountObjective1;
        var divided_by_5 = productQty / this.state.accountObjective2;
        var firstNum4 = parseInt(divided_by_4);
        var firstNum5 = parseInt(divided_by_5);
        
        return firstNum5;    
     }


   freeProductQtyTitle(productQty){

        var divided_by_5 = productQty / this.state.accountObjective2;
        var firstNum5 = parseInt(divided_by_5);
        return firstNum5;    
   }


  checkOfferProductCount(responseData, duplicateArrayRemoveOffer){

        var offerProductLastQty = 0;
        var offerproductsList = responseData;
        var productToBeAdded = '';
        var stringSplit = '';

        if(offerproductsList !== ''){
         // productToBeAdded = offerproductsList.productToBeAdded;
         // stringSplit = productToBeAdded.split(',');
        }

        var cartItemsFinal = JSON.parse(localStorage.getItem("cartItems"));

        if(duplicateArrayRemoveOffer !== ''){
            cartItemsFinal.map((cartItem) => {
                duplicateArrayRemoveOffer.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductLastQty += cartItem.qty;
                    }
                })
             });
        }

        this.setState({offerProductQty: offerProductLastQty}, function(){

            this.loadCartItems();
        });
    }

     redirectCheckout(){

        var cartTotal = this.state.cartOriginalTotal;

        if(cartTotal < this.state.settingsList.minimumOrderAmount){

             this.setState({
                navigate: false,
                minmumAmountError: true,
              });

            return false;
        
        }else{

            this.setState({
                navigate: true,
                minmumAmountError: false,
            });
        }

     }

    calcuatedTaxAmount(totalAmount){

        var TotalAmount = totalAmount;
        var TaxAmount = 0;
        TaxAmount = (totalAmount/100)*20;
        return TaxAmount.toLocaleString("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2
        });
    }

    openFreeProductListnew(){

        this.setState({freeProductListOpen: true});

    }

    loadCartItems() {

        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
       // cartItems.sort(this.dynamicSort("ProductGroup"));
        var freeProductIds = '';
        var typeFreeCount = 0;

        if(cartItems !=='' && cartItems !== null){
            cartItems.map((cartItem) =>{
             if(cartItem.product_type === 'Free'){
                freeProductIds = cartItem.productNumber;
                typeFreeCount++;
              }
         });
  
        localStorage.setItem('freeProductIds', freeProductIds); 

        return (<div className="cart-table">
            <div className="cart-table-header">
                <h4>Cart <span>({cartItems.length > 1 ? cartItems.length + ' Items' : cartItems.length + ' Item'})</span> {cartItems.length > 0 ? <span onClick={(e) => this.clearBasket(e)} className="clear-cart">Clear Cart</span> : '' }</h4>
                <div className='cart-mobile-header'>
                    <div className='cart-count'>
                        <i className="fa fa-shopping-cart"></i>
                        <span className="cart-count-txt">{cartItems.length}</span>
                    </div>
                    <div className='cart-total'>
                        <span>Total: <b>{this.state.cartTotal}</b></span>
                    </div>
                    <div className="cart-trig-open">
                        <a  onClick={(e) => this.expandCart()} ><span className='cart-trig-icon'></span></a>
                    </div>
                    <div className='cart-mob-chkout'>
                    {cartItems.length > 0 ? <a className="checkout-btn button" onClick={this.redirectCheckout.bind(this)}>Secure Checkout</a>
                     : <a className="checkout-btn button">Secure Checkout</a>}
                    </div>
                </div>
            </div>
            <div className="cart-table-body">
            {cartItems.length > 0 ?
               <div className='clear-cart-wrap'>
                    <span onClick={this.clearBasket.bind(this)} className="clear-cart">Clear Cart</span>
                </div> : ''}
                <ul className={this.state.cartLoader === true ? 'main-cat-cart loading-buffer' : 'main-cat-cart'}>

                  {cartItems.length > 0  && this.state.offerProductQty >= this.state.accountObjective1 && typeFreeCount === 0 && this.state.freeProductData.data !== undefined && this.state.freeProductData.data.length > 0 &&

                    <li className="free_product_list">
                    {this.state.offerProductQty <= 8 &&  
                    <div className='free-title-blk free-select-blk'> 
                    {this.state.offerProductQty > this.state.accountObjective1 ?
                        <h4>FREE Option <i className="fa fa-info-circle" aria-hidden="true" onClick={this.openFreeProductListnew.bind(this)}></i>
                        <span>When you select any {this.state.offerProductQty} sauces you will receive {this.freeProductQtyFour(this.state.offerProductQty)} x FREE pasta or {this.freeProductQtyTitle(this.state.offerProductQty)} x FREE rice </span></h4>
                        : <h4>FREE Option <i className="fa fa-info-circle" aria-hidden="true" onClick={this.openFreeProductListnew.bind(this)}></i>
                        <span>When you select any 4 sauces you will receive 1 x FREE pasta</span></h4>}

                        <span className="free_edit_btn" onClick={(e) => this.freeProductPopupOpen(e)}>Add</span>
                    </div>
                    }

                    {cartItems.length > 0 && this.state.offerProductQty >= 9 && typeFreeCount === 0 && 
                    <div className='free-title-blk free-select-blk'> 
                    <h4> FREE Option <i className="fa fa-info-circle" aria-hidden="true" onClick={this.openFreeProductListnew.bind(this)}></i><span>When you select any {this.state.offerProductQty} sauces you will receive {this.freeProductQtyFour(this.state.offerProductQty)} x FREE pasta or {this.freeProductQtyTitle(this.state.offerProductQty)} x FREE rice or a combination of both</span></h4>
                    <span className="free_edit_btn" onClick={(e) => this.freeProductPopupOpen(e)}>Add</span>
                    </div>
                    }
                    </li>
                    }

                    {cartItems.length > 0  && this.state.offerProductQty >= this.state.accountObjective1 && typeFreeCount > 0 && this.state.freeProductData.data !== undefined && this.state.freeProductData.data.length > 0 &&

                    <li className="free_product_list">
                    {this.state.offerProductQty <= 8 &&  
                    <div className='free-title-blk'> 
                     {this.state.offerProductQty > this.state.accountObjective1 ?
                        <h4>FREE Option <i className="fa fa-info-circle" aria-hidden="true" onClick={this.openFreeProductListnew.bind(this)}></i>
                        <span>When you select any {this.state.offerProductQty} sauces get {this.freeProductQtyFour(this.state.offerProductQty)} x free pasta or {this.freeProductQtyTitle(this.state.offerProductQty)} x free rice </span></h4>
                        : <h4>FREE Option <i className="fa fa-info-circle" aria-hidden="true" onClick={this.openFreeProductListnew.bind(this)}></i>
                         <span>When you select any 4 sauces you will receive 1 x FREE pasta</span></h4>}

                     <a className="free_edit_btn title-tooltip title-left" data-title='To change the FREE product setting using the edit icon.'><i className="fa fa-pencil" aria-hidden="true" onClick={(e) => this.freeProductPopupOpen(e)}></i></a>
                    </div>
                    }

                    {this.state.offerProductQty >= 9 && 
                      <div className='free-title-blk'> 
                    <h4> FREE Option <i className="fa fa-info-circle" aria-hidden="true" onClick={this.openFreeProductListnew.bind(this)}></i> <span>When you select any {this.state.offerProductQty} sauces get {this.freeProductQtyFour(this.state.offerProductQty)} x FREE pasta or {this.freeProductQtyTitle(this.state.offerProductQty)} x FREE rice or a combination of both</span></h4>
                      <a className="free_edit_btn title-tooltip title-left" data-title='To change the FREE product setting using the edit icon.'><i className="fa fa-pencil" aria-hidden="true" onClick={(e) => this.freeProductPopupOpen(e)}></i></a>
                    </div>
                    }

                   <ul className="free_product_list-inner">
                     {cartItems.map((item, index) => {
                        if(item.product_type === 'Free'){
                        return (<li className = "free_product_list-item"
                            key={index}>
                            <span className='cart-prod-delete' onClick={(e) => this.deleteSingleItem(e, item)}>x</span>
                            <div className="cart-prod-id">
                                <span className="prod-img-samp"><img src={CartCommonImage} /></span>
                                <span className={item.product_type === "Normal" ? "prod-title-txt" : "prod-title-txt free_product_title" }>{item.productDescription} ({item.productNumber})</span>
                            </div>
                            <div className="cart-prod-qty">
                                <span className="qty-val-action qty-val-minus" onClick={(e) => this.decreaseQty(e,item)}>-</span>
                                <input className="qty-number" type="text" readOnly value={item.qty} min="0" />
                                <span className="qty-val-action qty-val-plus" onClick={(e) => this.increaseQty(e, item)}>+</span>
                                 
                            </div>
                            <div className="cart-prod-total">
                            {item.product_type ==="Normal" ?
                                <span className='cart-prod-amt'>{this.priceFormat(item.PDP_Price1 * item.qty)}</span> : <span className='cart-prod-amt'>FREE</span>}
                            </div>
                        </li>)
                       }
                      })}
                    </ul>
                    </li>
                    }

                    {cartItems.map((item, index) => {
                        if(item.product_type === 'Normal'){
                        return (<li className = "Normal"
                            key={index}>
                            <span className='cart-prod-delete' onClick={(e) => this.deleteSingleItem(e, item)}>x</span>
                            <div className="cart-prod-id">
                                <span className="prod-img-samp"><img src={CartCommonImage} /></span>
                                <span className="prod-title-txt">{item.productDescription} ({item.productNumber}){item.productTaxVal> 0 && <span className='color-red'>*</span>}</span>
                            </div>
                            <div className="cart-prod-qty">
                                <span className="qty-val-action qty-val-minus" onClick={(e) => this.decreaseQty(e,item)}>-</span>
                                <input className="qty-number" type="text" readOnly value={item.qty} min="0" />
                                <span className="qty-val-action qty-val-plus" onClick={(e) => this.increaseQty(e, item)}>+</span>
                            </div>
                            <div className="cart-prod-total">
                            <span className='cart-prod-amt'>{this.priceFormat(item.PDP_Price1 * item.qty)}</span>
                            </div>
                        </li>)
                     }
                    })}


                    {cartItems.length < 1 && <li>Your Cart is Empty!</li>}
                 </ul>
              
                {cartItems.length > 0 && <div className="cart-table-bottom">
                    <div className='cart-all-prod-total'>
                        <h5>Sub Total</h5>
                        <span className='cart-prod-total-val'>{this.state.cartSubTotal}</span>
                    </div>
                    {this.state.taxProductTotalAmount > 0 && 
                    <div className='cart-all-prod-total'>
                        <h5>VAT (20% of <span className='vat-amt'>{this.priceFormat(this.state.taxProductTotalAmount)}</span>)<span className='color-red'>*</span></h5>
                        <span className='cart-prod-total-val'>{this.calcuatedTaxAmount(this.state.taxProductTotalAmount)}</span>
                    </div>
                    }
                    <div className='cart-all-prod-total'>
                        <h5>Shipping</h5>
                        <span className='cart-prod-total-val color-red'>FREE</span>
                    </div>
                    <div className='cart-all-prod-total'>
                        <h5>Total</h5>
                        <span className='cart-prod-total-val'>{this.state.cartTotal}</span>
                    </div>
                    <div className='cart-checkout-button'>
                        <a className="checkout-btn button" onClick={this.redirectCheckout.bind(this)}> Secure Checkout</a>
                    </div>
                </div>}
            </div>
        </div>);
      }
    }

    highlightAllergens(str) {

        this.state.allergens.forEach((substr) => {

            var strRegExp = new RegExp("\\b"+ substr +"\\b","ig");

            str = str.replace(strRegExp, '<strong>' + substr + '</strong>');

        });

        return <div dangerouslySetInnerHTML={{ __html: str }} />
    }

    hightLightIngredients(str){

       this.state.ingredientsHigh.forEach((substr) => {
            var strRegExp = new RegExp("\\b"+substr+"\\b","ig")
            str = str.replace(strRegExp, '<strong>' + substr + '</strong>');
        });

        return <div dangerouslySetInnerHTML={{ __html: str }} />

    }

    clearBasket() {

      this.setState({clear_cart: true, freeProductOpen: false, delete_item_popup: false, delete_item_popup: false, common_alert_popup:false, minmumAmountError: false});
    }

   clearCart(){

     var cartItems = JSON.parse(localStorage.getItem("cartItems"));
       cartItems.map(function (cartItem) {
        if (cartItem.qty > 0) {
            this.setState({ [cartItem.productNumber]: 0 });
        } else {
            this.setState({ [cartItem.productNumber]: 0 });
        }
      }, this);

      var empty = [];
      localStorage.setItem('cartItems', JSON.stringify(empty));
      var cartTotal = 0;
      this.setState({ cartAdded: false, freeProductOpen:false, cartTotal: this.priceFormat(cartTotal), clear_cart:false, delete_item_popup: false, delete_item_popup: false, common_alert_popup:false, minmumAmountError: false});

     var element = document.getElementById("cart-side-table");
         element.classList.remove("open");

    }
 

    handlePopup = (e, item) => {

     this.setState({ cartAdded: false, freeProductOpen:false, clear_cart:false, delete_item_popup: false, delete_item_popup: false, common_alert_popup:false, minmumAmountError: false});

        let viewInfo = <Popup
            extClass="info-poup show"
            closebtn={<><span onClick={() => this.setState({ viewInfo: "" })} className='close'></span></>}
            headMoreTxt={
                <>
                    <div className="order-top">
                        <h4><span>{item.productDescription} - {item.productNumber}</span></h4>

                    </div>
                </>
            }

            bodyMoreTxt={
                <>
                    <div className="info-bdy"> 
                        {item.packageSize !== null && item.packageSize !== "" &&
                            <div className="info-item">
                                <div className="info-innr">
                                    <h5><span>Unit of Sale</span></h5>
                                    <p>
                                        {item.packageSize}
                                    </p>
                                </div>
                            </div>
                        }

                        {item.productIngredient !== null && item.productIngredient !== "" &&
                            <div className="info-item">
                                <div className="info-innr">
                                    <h5><span>Ingredients</span></h5>
                                    <p>
                                     {this.hightLightIngredients(item.productIngredient)}
                                    </p>
                                </div>
                            </div>
                        }

                        {item.productSpec !== null && item.productSpec !== "" &&
                            <div className="info-item">
                                <div className="info-innr">
                                    <h5><span>Product Specification</span></h5>
                                    <p>
                                        <a target="_blank" href={item.productSpec} >Click here </a> for Information on ingredients not included in the 14 allergens, nutritional values, usage instructions and storage/shelf life
                                    </p>
                                </div>
                            </div>
                        }

                        {item.productUSP !== null && item.productUSP !== "" &&
                            <div className="info-item">
                                <div className="info-innr">
                                    <h5><span>Allergens</span></h5>
                                    <p>
                                        {(item.productUSP === 'No Allergens' || item.productUSP === 'No Allegens'  || item.productUSP === 'No Allegen')? "Doesn't contain any of the 14 most potent and prevalent allergens required to be declared by food law" : this.highlightAllergens(item.productUSP)}

                                    </p>
                                </div>
                            </div>
                        }

                        {item.productDiet !== null && item.productDiet !== "" &&
                            <div className="info-item">
                                <div className="info-innr">
                                    <h5><span>Diet Suitablity</span></h5>
                                    <p>
                                        {item.productDiet}
                                    </p>
                                </div>
                            </div>
                        }

                    </div>
                </>
            }
        />


        this.setState({ viewInfo: viewInfo, minmumAmountError: false })

    }


    handleImage = (e, item) => {

        console.log(item, 'item');

        //e.preventDefault();

        this.setState({ cartAdded: false, freeProductOpen:false, clear_cart:false, delete_item_popup: false, delete_item_popup: false, common_alert_popup:false, minmumAmountError: false});


        let viewdddImage = "";

        viewdddImage = <Popup
            extClass="prt-poup prt-img-poup show"
            closebtn={<><span onClick={() => this.setState({ viewImage: "" })} className='close'></span></>}
            headMoreTxt={
                <>
                    <div className="order-top">
                        <h4><span>{item.productDescription} ({item.productNumber})</span></h4>

                    </div>
                </>
            }
            bodyMoreTxt={
                <>
                    <div className="prt-bdy-img">
                        <img src={item.productImage !=='' && item.productImage !== null ? item.productImage: NoImage} alt="Product" />
                        <div className="prt-dsc">
                            <span className="pop-prt-txt">{item.productName} </span>
                        </div>
                    </div>
                </>
            }
        />

        this.setState({ productImageIndex: e });
        this.setState({ viewImage: viewdddImage, minmumAmountError: false });
    }

    handleChange(item, evt) {
      
        var value = evt.target.value;

        if(value > 0){
            value  = parseInt(value);
        }

        this.setState({ [item.productNumber]: value, freeProductIds: '', freeProductOpen: false, clear_cart: false, delete_item_popup: false, delete_item_popup_free:false, common_alert_popup: false, minmumAmountError: false}, function(){

        });

    }

    handleChangeSearch(value) {
        this.setState({ searchText: value, freeProductOpen: false, clear_cart: false, delete_item_popup: false, delete_item_popup_free:false, common_alert_popup:false, minmumAmountError: false});
        this.searchProduct(value);

    }

    clearSearch() {

        this.setState({ searchText: "" });
        var filterByValue = this.state.filterSelectedValue;

        if(this.state.filterSelectedValue.length > 0){

        var productsList = this.state.tempproducts;

        var filterBy = { SuitableFor: this.state.filterSelectedValue};

        var filterBy = productsList.filter(function (o) {
            return Object.keys(filterBy).every(function (k) {
                return filterBy[k].some(function (f) {
                    return o[k] === f;
                });
            });
        });

        filterBy = filterBy;

        let groupProductsList = [];

        this.state.groupFilterList.map((item) => {

        let productGroup = [];
         
         filterBy.map((product) => {

            if (item === product.ProductGroup){
                productGroup.push(product);
            }

         });

        if(productGroup.length > 0){
           groupProductsList.push({ [item]: productGroup }); 
        }

        });

         this.setState({ products: filterBy, freeProductOpen: false, clear_cart: false, delete_item_popup: false, delete_item_popup_free:false, common_alert_popup:false, minmumAmountError: false, groupProductsList: groupProductsList});

        }else{


        let groupProductsList = [];

        this.state.groupFilterList.map((item) => {

        let productGroup = [];
         
         this.state.tempproducts.map((product) => {

            if (item === product.ProductGroup){
                productGroup.push(product);
            }

         });

        if(productGroup.length > 0){
           groupProductsList.push({ [item]: productGroup }); 
        }

        });


        this.setState({ products: this.state.tempproducts, freeProductOpen: false, clear_cart: false, delete_item_popup: false, delete_item_popup_free:false, common_alert_popup:false,minmumAmountError: false, groupProductsList: groupProductsList });
        }
        
    }

    searchProduct(value) {
        const lowercasedValue = value.toLowerCase().trim();
        var filterByValue = this.state.filterSelectedValue;
        var filteredData = '';

        if(this.state.filterSelectedValue.length > 0){

        var productsList = this.state.tempproducts;

        var filterBy = { SuitableFor: this.state.filterSelectedValue};

        var filterBy = productsList.filter(function (o) {
            return Object.keys(filterBy).every(function (k) {
                return filterBy[k].some(function (f) {
                    return o[k] === f;
                });
            });
        });

          filteredData = filterBy.filter((item) => {
            return item.productNumber.toLowerCase().includes(lowercasedValue) || item.productDescription.toLowerCase().includes(lowercasedValue)
          });

        }else{

           filteredData = this.state.tempproducts.filter((item) => {
            return item.productNumber.toLowerCase().includes(lowercasedValue) || item.productDescription.toLowerCase().includes(lowercasedValue)
          });

        }

        let groupProductsList = [];

        this.state.groupFilterList.map((item) => {

        let productGroup = [];
         
         filteredData.map((product) => {

            if (item === product.ProductGroup){
                productGroup.push(product);
            }

         });

        if(productGroup.length > 0){
           groupProductsList.push({ [item]: productGroup }); 
        }

        });

        this.setState({ products: filteredData, freeProductOpen: false, clear_cart: false, delete_item_popup: false, delete_item_popup_free:false, common_alert_popup:false, minmumAmountError: false, groupProductsList: groupProductsList});
    }

    enablePopup(item) {
        if ((item.productUSP !== null && item.productUSP !== "") || (item.productDiet !== null && item.productDiet !== "") || (item.productIngredient !== null && item.productIngredient !== "") || (item.productSpec !== null && item.productSpec !== "")) {
            return true;
        } else {
            return false;
        }
    }

      validateIntval(e) {
        const re = /[0-9]+/g;
        if (!re.test(e.key)) {
          e.preventDefault();
        }
      }


      popupClose(){

        this.setState({
            common_alert_popup: false, 
            freeProductOpen: false,
            clear_cart:false,
            delete_item_popup: false,
            delete_item_popup_free:false,
            decrease_alert_popup: false,
            delete_item_alert_popup: false,
            minmumAmountError: false,
            minimumOrderAmounterror: false,

        });

        localStorage.removeItem('minimumOrderAmounterror');


      }

      freeProductClear(){

        var removeFreeProduct = this.state.removeFreeProduct;

        this.removeFreeProduct(this.state.removeFreeProduct);

        this.setState({
            common_alert_popup: false,
        });

      }

      replaceFreeProduct(item){

        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var freeProductList = this.state.freeProductData;
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = offerproductsList.productToBeAdded;
        var stringSplit = productToBeAdded.split(',');
        var newitems = [];

        var freeProductExist = '0';
        cartItems.map((cartItem) =>{
         if(cartItem.product_type === 'Free'){
             freeProductExist++;
            }
         });


        if(item.product_type === 'Free'){
          newitems = cartItems.filter((cartItem) => (cartItem.product_type !== 'Free'));
          localStorage.setItem('cartItems', JSON.stringify(newitems));
          this.updateStateValue();
        }

      }

      removeFreeProduct(item){

       var cartItems = JSON.parse(localStorage.getItem("cartItems"));
       var freeProductList = this.state.freeProductData;
       var offerproductsList = this.state.offerproducts;
       var productToBeAdded = '';
       var stringSplit = this.state.offerCombineProducts;

       if(offerproductsList !== '' && offerproductsList !==''){
         productToBeAdded = offerproductsList.productToBeAdded;
         //stringSplit = productToBeAdded.split(',');
       }   

       this.setState({ loading: true, reloadCart: false });

       var newitems = [];
       var newitemsTest = [];
       var returnProductNumberNew = 0;

       if(stringSplit !== ''){

          stringSplit.filter(function(value) {

            if(value ===  item.productNumber){

                returnProductNumberNew = value;

            }
               
         });
       }

       if(item.product_type === 'Free'){

       if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === item.productNumber && cartItem.product_type === 'Free'))) {

        if(item.product_type === 'Free'){

         newitems = cartItems.map((cartItem) =>

            cartItem.productNumber === item.productNumber && cartItem.product_type === 'Free'
                ? {
                    ...cartItem, 
                    qty: 0
                }
                : cartItem
         );

          localStorage.setItem('cartItems', JSON.stringify(newitems));
          this.updateStateValue();
          newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
        
        }

        localStorage.setItem('cartItems', JSON.stringify(newitems));
        this.updateStateValue();

         this.setState({ reloadCart: true, loading: false, common_alert_message: '', common_alert_popup: false, removeFreeProduct: '' });
        }

      }else{

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === item.productNumber && cartItem.product_type === 'Normal'))) {

            if(item.product_type === 'Normal'){

            var product_qty = this.state.addtoCartTypeQty;

             newitems = cartItems.map((cartItem) =>

                cartItem.productNumber === item.productNumber && cartItem.product_type === 'Normal'
                    ? {
                        ...cartItem, 
                        qty: (product_qty !== '' ? product_qty : cartItem.qty - 1 )
                    }
                    : cartItem
                
             );

              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
              localStorage.setItem('cartItems', JSON.stringify(newitems));
              this.updateStateValue();
            }

            localStorage.setItem('cartItems', JSON.stringify(newitems));
            this.updateStateValue();

            this.setState({addtoCartTypeQty: ''});

          }

        var checkFreeItems = JSON.parse(localStorage.getItem("cartItems"));

        var freeProductExist = 0;
         checkFreeItems.map((cartItem) =>{
         if(cartItem.product_type === 'Free'){
             freeProductExist++;
            }
         });

        var offerProductQty = 0;

            checkFreeItems.map((cartItem) => {
                stringSplit.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductQty += cartItem.qty;
                    }
                })
         });

        console.log(freeProductExist, 'freeProductExistfreeProductExistfreeProductExistfreeProductExist');


        
         if(freeProductExist > 1 && (offerProductQty < this.state.accountObjective1 || offerProductQty ==  this.state.accountObjective1)){

             var newitemsLastFinal = [];

            newitemsLastFinal = checkFreeItems.filter((cartItem) => (cartItem.product_type !== 'Free'));

            localStorage.setItem('cartItems', JSON.stringify(newitemsLastFinal));

            this.setState({common_alert_popup: false, removeFreeProduct: [], common_alert_message: ''});

         }
     
        if(freeProductExist == 1 && offerProductQty < this.state.accountObjective1){
            
          var newitemsLast4 = [];

          freeProductList.data.map((data, index)=>{

          if (checkFreeItems !== null && checkFreeItems.some((cartItem) => cartItem.productNumber === data.productNumber)) {

            if(this.state.accountObjective1 > offerProductQty){

              newitemsLast4 = checkFreeItems.filter((cartItem) => (cartItem.product_type !== 'Free'));

              localStorage.setItem('cartItems', JSON.stringify(newitemsLast4));

            } 
          }

         });

          this.updateStateValue();
          this.setState({checkedItems: [], freeProductOpen:false, offerProductQty: offerProductQty});
          localStorage.setItem('freeProductIds', '');

        }else if(freeProductExist == 1 && offerProductQty == this.state.accountObjective1){

        var newitemsLast = [];

         freeProductList.data.map((data, index)=>{

          if (checkFreeItems !== null && checkFreeItems.some((cartItem) => cartItem.productNumber === data.productNumber)) {

            newitemsLast = checkFreeItems.filter((cartItem) => (cartItem.product_type !== 'Free'));

            localStorage.setItem('cartItems', JSON.stringify(newitemsLast));

          }

        });

         localStorage.setItem('freeProductIds', '');

         this.setState({checkedItems: [], freeProductOpen:false, offerProductQty: offerProductQty});

            var cartItemsLast = JSON.parse(localStorage.getItem("cartItems"));
            var offerproductQtyRemaing = 0;
            var productFourqty  = 0;
            var productFiveqty  = 0;
            var totalCount = 0;
            var totalCount1 = 0;
            var calculatedTotal = 0;
            var offerProductLastQty = 0;
            var typeFree = 0;


           cartItemsLast.map((freeItem)=>{

             stringSplit.filter(function(value) {
                if(freeItem.productNumber === value){
                    offerProductLastQty += freeItem.qty;
                }
              })

            });

            cartItemsLast.map((freeItem)=>{

            var increment = this.state.accountObjective1;
            var increment1 = this.state.accountObjective2;

             if(freeItem.product_type === 'Free'){

               typeFree++;

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                increment1 = this.state.accountObjective2;
                productFiveqty = freeItem.qty;
              }else{
                increment = this.state.accountObjective1;
                productFourqty += freeItem.qty;
              }


              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;

              calculatedTotal = totalCount + totalCount1;

              offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
           }

          });

         if(typeFree === 0){
           offerproductQtyRemaing = offerProductLastQty;
         }


       //  console.log('offerproductQtyRemaing', offerproductQtyRemaing);


        if(offerproductQtyRemaing !=='' && returnProductNumberNew !== 0){

            this.freeProductQtyUpdateOnly(offerproductQtyRemaing, 'decrease');
        } 

    
        localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
        localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);


         if(returnProductNumberNew !== 0){
            this.setState({checkedItems: [], freeProductOpen:true, offerProductQty:offerProductLastQty, offerproductQtyRemaing: offerproductQtyRemaing});
      
         }
         
        }

        var cartItemsLastFinal = JSON.parse(localStorage.getItem("cartItems"));
        var NormalProductCheck = 0;

        cartItemsLastFinal.map((freeItemLast)=>{
            if(freeItemLast.product_type === 'Normal'){
                NormalProductCheck++;
            }
        });

        var newitemsLastFinal = [];

        if(NormalProductCheck == 0){

            newitemsLastFinal = checkFreeItems.filter((cartItem) => (cartItem.product_type !== 'Free'));

            localStorage.setItem('cartItems', JSON.stringify(newitemsLastFinal));

        }

        this.setState({ reloadCart: true, loading: false });
     }

    }

    removeMultipleFreeProduct(){

        var decrease_product = this.state.decreaseItem;
        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var newitems = [];

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === decrease_product.productNumber && cartItem.product_type === 'Normal'))) {

             newitems = cartItems.map((cartItem) =>

                cartItem.productNumber === decrease_product.productNumber && cartItem.product_type === 'Normal'
                    ? {
                        ...cartItem, 
                        qty: (this.state.decrease_alert_qty > 0 ? this.state.decrease_alert_qty : cartItem.qty - 1)
                    }
                    : cartItem
                
             );

              localStorage.setItem('cartItems', JSON.stringify(newitems));
              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
              this.updateStateValue();

        }


        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = '';
        if(offerproductsList !== '' && offerproductsList !==''){
        var productToBeAdded = offerproductsList.productToBeAdded;
        var stringSplit = productToBeAdded.split(',');
        }

        var previousofferProductQty = 0;
        var returnProductNumber = 0;
        var freeProductCount = 0;
        
        if(stringSplit !== ''){
            cartItems.map((cartItem) => {
                if(cartItem.product_type === 'Free'){
                    freeProductCount++;
                }
                stringSplit.filter(function(value) {
                   if(value ===  decrease_product.productNumber){
                      returnProductNumber = value;
                   }
                   if(value === cartItem.productNumber && cartItem.product_type !== 'Free'){
                      previousofferProductQty += cartItem.qty;
                   }

                });
             });
         }

         var newitemsLastFinal = [];

         if(freeProductCount > 1){

            newitemsLastFinal = cartItemsNew.filter((cartItem) => (cartItem.product_type !== 'Free'));

            localStorage.setItem('cartItems', JSON.stringify(newitemsLastFinal));

            this.setState({decrease_alert_popup: false, decrease_alert_popup_message: '', decrease_alert_qty: 0, decreaseItem: []});
         }


            var cartItemsLast = JSON.parse(localStorage.getItem("cartItems"));
            var offerproductQtyRemaing = 0;
            var productFourqty  = 0;
            var productFiveqty  = 0;
            var totalCount = 0;
            var totalCount1 = 0;
            var calculatedTotal = 0;
            var offerProductLastQty = 0;
            var typeFree = 0;

          if(stringSplit !== ''){
            cartItemsLast.map((freeItem)=>{
             stringSplit.filter(function(value) {
                if(freeItem.productNumber === value){
                    offerProductLastQty += freeItem.qty;
                }
              })
            });
           }
           
           cartItemsLast.map((freeItem)=>{

            var increment = this.state.accountObjective1;
            var increment1 = this.state.accountObjective2;

             if(freeItem.product_type === 'Free'){

               typeFree++;

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                increment1 = this.state.accountObjective2;
                productFiveqty = freeItem.qty;
              }else{
                increment = this.state.accountObjective1;
                productFourqty += freeItem.qty;
              }


              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;
              calculatedTotal = totalCount + totalCount1;

              offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
           }

          });

         if(typeFree === 0){
           offerproductQtyRemaing = offerProductLastQty;
         }
    
        localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
        localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

        if(returnProductNumber !== 0 && (offerproductQtyRemaing == this.state.accountObjective1 || offerproductQtyRemaing > this.state.accountObjective1)){
            this.setState({checkedItems: [], freeProductOpen:true, offerProductQty:offerProductLastQty, offerproductQtyRemaing: offerproductQtyRemaing, decrease_alert_qty: 0, decreaseItem: []});
        }

    }


    removeSingleOfferProduct(){

        var delete_single_Item = this.state.delete_single_Item;
        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var newitems = [];

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === delete_single_Item.productNumber && cartItem.product_type === 'Normal'))) {

             newitems = cartItems.map((cartItem) =>

                cartItem.productNumber === delete_single_Item.productNumber && cartItem.product_type === 'Normal'
                    ? {
                        ...cartItem, 
                        qty: 0,
                    }
                    : cartItem
                
             );

              localStorage.setItem('cartItems', JSON.stringify(newitems));
              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
              this.updateStateValue();

        }
        
        localStorage.setItem('cartItems', JSON.stringify(newitems));

        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;
        if(offerproductsList !== ''){
          productToBeAdded = offerproductsList.productToBeAdded;
        //var stringSplit = productToBeAdded.split(',');
        }

        var previousofferProductQty = 0;
        var returnProductNumber = 0;
        var freeProductCount = 0;
        
        if(stringSplit !== ''){
            cartItems.map((cartItem) => {
                if(cartItem.product_type === 'Free'){
                    freeProductCount++;
                }
                stringSplit.filter(function(value) {
                   if(value ===  delete_single_Item.productNumber){
                      returnProductNumber = value;
                   }
                   if(value === cartItem.productNumber && cartItem.product_type !== 'Free'){
                      previousofferProductQty += cartItem.qty;
                   }

                });
             });
         }

         var newitemsLastFinal = [];

         if(freeProductCount > 1){

            newitemsLastFinal = cartItemsNew.filter((cartItem) => (cartItem.product_type !== 'Free'));

            localStorage.setItem('cartItems', JSON.stringify(newitemsLastFinal));

            this.setState({delete_item_alert_popup: false, delete_single_Item: [], delete_item_alert_message: ''});

         }
        
         var cartItemsLast = JSON.parse(localStorage.getItem("cartItems"));
         var offerproductQtyRemaing = 0;
         var productFourqty  = 0;
         var productFiveqty  = 0;
         var totalCount = 0;
         var totalCount1 = 0;
         var calculatedTotal = 0;
         var offerProductLastQty = 0;
         var typeFree = 0;

          if(stringSplit !== ''){
           cartItemsLast.map((freeItem)=>{
             stringSplit.filter(function(value) {
                if(freeItem.productNumber === value){
                    offerProductLastQty += freeItem.qty;
                }
              })
            });
           }

         if (freeProductCount == 1){

            this.setState({delete_item_alert_popup: false, delete_single_Item: [], delete_item_alert_message: ''});
            this.freeProductQtyUpdateOnly(offerProductLastQty, 'decrease');
         }

          this.setState({delete_item_alert_popup: false, delete_single_Item: [], delete_item_alert_message: ''});

          var cartItemsLastAfter = JSON.parse(localStorage.getItem("cartItems"));

           cartItemsLastAfter.map((freeItem)=>{

            var increment = this.state.accountObjective1;
            var increment1 = this.state.accountObjective2;

             if(freeItem.product_type === 'Free'){

               typeFree++;

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                increment1 = this.state.accountObjective2;
                productFiveqty = freeItem.qty;
              }else{
                increment = this.state.accountObjective1;
                productFourqty += freeItem.qty;
              }

              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;

              calculatedTotal = totalCount + totalCount1;
              offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
           }

          });

        // console.log(offerProductLastQty, 'offerProductLastQty');
        // console.log(typeFree, 'typeFree');

         if(typeFree == 0){
           offerproductQtyRemaing = offerProductLastQty;
         }
    
        localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
        localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

        // console.log(returnProductNumber, 'returnProductNumber');
        // console.log(this.state.accountObjective1, 'this.state.accountObjective1');
        // console.log(offerproductQtyRemaing, 'offerproductQtyRemaing');

        var offerProductLastQtyLast = 0; 

          if(stringSplit !== ''){
           cartItemsLast.map((freeItem)=>{
             stringSplit.filter(function(value) {
                if(freeItem.productNumber === value){
                    offerProductLastQtyLast += freeItem.qty;
                }
              })
            });
          }

        //console.log(offerProductLastQtyLast, 'offerProductLastQtyLast');

        if(returnProductNumber !== 0 && (offerproductQtyRemaing == this.state.accountObjective1 || offerproductQtyRemaing > this.state.accountObjective1)){


            var fourValue = this.state.accountObjective1;
            var fiveValue = this.state.accountObjective2;
            var retunrFour4 = this.checkIfMultiple(offerProductLastQtyLast, fourValue);
            var retunrFour5 = this.checkIfMultiple(offerProductLastQtyLast, fiveValue);

            if(retunrFour4 == true){

                this.setState({checkedItems: [], freeProductOpen:true, offerProductQty:offerProductLastQty, offerproductQtyRemaing: offerproductQtyRemaing, decrease_alert_qty: 0, decreaseItem: []});
            }

            if(retunrFour5 == true){

                this.setState({checkedItems: [], freeProductOpen:true, offerProductQty:offerProductLastQty, offerproductQtyRemaing: offerproductQtyRemaing, decrease_alert_qty: 0, decreaseItem: []});

            }
        }
    }

    handleHoverOff(){

     this.setState({imageHover: false});

    }

    filterChange = (event) =>{

     var filterValue = event.target.value;

     if(this.state.tempproducts.length > 0){

     if(filterValue !== ''){

     this.setState({filterByValue: filterValue});

      var productsList = this.state.tempproducts;

      const newItem = productsList.filter((newVal) => {

           return newVal.SuitableFor === filterValue;

           });

        this.setState({ products: newItem});

     }else{

        this.setState({filterByValue: ''});
        this.setState({ products: this.state.tempproducts});
     }

    }
     

    }

    openFilterOption = () => {

        this.setState(prevState => ({
          isElementVisible: !prevState.isElementVisible
        }));

        this.setState({minmumAmountError: false});

    }


    openFilterOptionMobile = () => {

        this.setState(prevState => ({
          isElementVisibleMobile: !prevState.isElementVisibleMobile
        }));

        this.setState({minmumAmountError: false});

    }


    


    searchFilter(value){

          if(value != ''){

            if(!this.state.filterSelectedValue.includes(value)){

                this.setState((prevState) => ({
                filterSelectedValue: [...prevState.filterSelectedValue, value],
                }));

                 NewArray.push(value);

                 localStorage.setItem("filterAttr",  NewArray);
                // this.setState({filterSelectedValue: NewArray});

                 this.setState({minmumAmountError: false});

            }else if(this.state.filterSelectedValue.includes(value) === true){


                  var arr = this.state.filterSelectedValue;

                    var newArr = NewArray;

                    arr = arr.filter(val => val !== value);

                    newArr = arr.filter(val1 => val1 !== value);

                    localStorage.setItem("filterAttr",  arr);

                    NewArray = newArr;

                   this.setState({filterSelectedValue: arr, minmumAmountError: false});

                      if(arr.length === 0){

                                let groupProductsList = [];

                                this.state.groupFilterList.map((item) => {

                                let productGroup = [];
                                 
                                 this.state.tempproducts.map((product) => {

                                    if (item === product.ProductGroup){
                                        productGroup.push(product);
                                    }

                                 });

                                if(productGroup.length > 0){
                                   groupProductsList.push({ [item]: productGroup }); 
                                }

                                });
                           this.setState({ products: this.state.tempproducts, groupProductsList: groupProductsList });
                        }

            }

          }
    }

    removeFilter(e, value){

        var arr = this.state.filterSelectedValue;

        var newArr = NewArray;

        arr = arr.filter(val => val !== value);

        newArr = arr.filter(val1 => val1 !== value);

        localStorage.setItem("filterAttr",  arr);

        //NewArray = newArr;

        this.setState({filterSelectedValue: arr,  minmumAmountError: false}, function(){

            this.applyFilter();
        });

        if(arr.length === 0){

        let groupProductsList = [];

        this.state.groupFilterList.map((item) => {

        let productGroup = [];
         
         this.state.tempproducts.map((product) => {

            if (item === product.ProductGroup){
                productGroup.push(product);
            }

         });

        if(productGroup.length > 0){
           groupProductsList.push({ [item]: productGroup }); 
        }

        });

           this.setState({ products: this.state.tempproducts, groupProductsList: groupProductsList});
        }

    }

    clearFilterSearch(){
        NewArray = [];
        this.setState({filterSelectedValue: []});


        let groupProductsList = [];

        this.state.groupFilterList.map((item) => {

        let productGroup = [];
         
         this.state.tempproducts.map((product) => {

            if (item === product.ProductGroup){
                productGroup.push(product);
            }

         });

        if(productGroup.length > 0){
           groupProductsList.push({ [item]: productGroup }); 
        }

        });

        this.setState({ products: this.state.tempproducts, freeProductOpen: false, clear_cart: false, delete_item_popup: false, delete_item_popup_free:false, common_alert_popup:false,minmumAmountError: false, groupProductsList: groupProductsList });
    }

    applyFilter(){

        if(this.state.filterSelectedValue.length > 0){

        let responseData2 = this.state.tempproducts;

        var filterBy = { SuitableFor: this.state.filterSelectedValue};

        var filterBy = responseData2.filter(function (o) {
            return Object.keys(filterBy).every(function (k) {
                return filterBy[k].some(function (f) {
                    return o[k] === f;
                });
            });
        });

        if(filterBy.length > 0){

            filterBy = filterBy;

        }


        let groupProductsList = [];

        this.state.groupFilterList.map((item) => {

        let productGroup = [];
         
         filterBy.map((product) => {

            if (item === product.ProductGroup){
                productGroup.push(product);
            }

         });

        if(productGroup.length > 0){
           groupProductsList.push({ [item]: productGroup }); 
        }

        });


        this.setState({ products: filterBy, isElementVisible: false, isElementVisibleMobile: false, groupProductsList: groupProductsList});

       }else{

        this.setState({isElementVisible: false, isElementVisibleMobile: false });

       }

    }


    render() {

        var siteUrl =  window.location.pathname.split('/').pop();
        var activeSlide = 0;
        var searchPlaceholder = '';

        if(siteUrl == 'pizza'){
            activeSlide = 0;
            searchPlaceholder = 'Pizza';
        }else  if(siteUrl == 'pasta-rice-noodle-sauces'){
            activeSlide = 1;   
            searchPlaceholder = 'Pasta, Rice & Noodle Sauces';
        }else if(siteUrl == 'burrito'){
            activeSlide = 2;
            searchPlaceholder = 'Burrito';
        }

        var settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            initialSlide: activeSlide,
            responsive: [
                {
                    breakpoint: 860,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 680,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        initialSlide: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        const currentcat = window.location.pathname.split('/').pop();

        const { navigate } = this.state;

        if (navigate) {
          return <Navigate to="/checkoutpay" push={true} />;
        }

        var secondLine = ", please add additional items to your cart and proceed to checkout.";

        var minmumAmount = "You have not reached your minimum order amount of £"+this.state.minimumOrderAmount + secondLine;

        return (
            <>
                <Header />
                {!this.state.loading &&
                    <main className='main-section'>
                    <section className="checkout-block">
                        <div className="sm-container">
                            <div className='prod-slider-list'>
                                <div className='prod-slider'>
                                    <Slider {...settings}>
                                        <a href="/checkout/pizza" className={currentcat === 'pizza' ? "prod-slider-active" : ""}>
                                            <div className='prod-slides'>
                                                <div className='prod-slide-img'>
                                                    <img src={Cartitem1} className="cart-back" alt="Cart" />
                                                </div>
                                                <div className='prod-slide-name'>
                                                    <p>Pizza</p>
                                                </div>
                                            </div>
                                        </a>
                                        <a href="/checkout/pasta-rice-noodle-sauces" className={currentcat === 'pasta-rice-noodle-sauces' ? "prod-slider-active" : ""}>
                                            <div className='prod-slides'>
                                                <div className='prod-slide-img'>
                                                    <img src={Cartitem2} className="cart-back" alt="Cart" />
                                                </div>
                                                <div className='prod-slide-name'>
                                                    <p>Pasta, Rice & <br></br>Noodle Sauces</p>
                                                </div>
                                            </div></a>
                                        <a href="/checkout/burrito" className={currentcat === 'burrito' ? "prod-slider-active" : ""}>
                                            <div className='prod-slides'>
                                                <div className='prod-slide-img'>
                                                    <img src={Cartitem3} className="cart-back" alt="Cart" />
                                                </div>
                                                <div className='prod-slide-name'>
                                                    <p>Burrito</p>
                                                </div>
                                            </div>
                                        </a>
                                    </Slider>
                                </div>
                            </div>

                            <div className='checkout-header'>
                                <h1 className="checkout-title">{this.state.pageTitle}</h1>
                                <div className='filter-option-mob'>
                                    <div className= {this.state.filterValueList.length > 0 ? 'select-drop mobile-drop' : 'select-drop mobile-drop no-filter-list'} ref={this.dropdownMobileRef}>

                                        <a className={this.state.isElementVisibleMobile == true ? 'filter-btn button active' : 'filter-btn button'} onClick={this.openFilterOptionMobile}>More Filter <span className='filter-icon'><i className="fa fa-sliders" aria-hidden="true"></i></span></a>


                                        <div className={this.state.isElementVisibleMobile == true ? 'filter-bx show' : 'filter-bx'}>

                                            {this.state.filterValueList.length == 0 && 
                                             <div className='no-filter'>
                                             <p>Sorry, no filters are set for this category.</p>
                                             </div>
                                            }

                                            <div className= {this.state.isElementVisibleMobile == true ? 'filter-options active' : 'filter-options'}>

                                              {this.state.filterValueList.length > 0 && this.state.filterValueList.map((item, index)=>{
                                                return (<a className= {!this.state.filterSelectedValue.includes(item) ? 'filter-val' : 'filter-val active'} onClick={this.searchFilter.bind(this, item)}>{item} <span className='remove-filter' onClick={(e) => this.removeFilter(e, item)}></span></a>)

                                              })}

                                            </div>

                                            {this.state.filterValueList.length > 0 &&
                                            <div className='filter-btns'>
                                                <button type="button" className="button clear-btn" value="Clear Filters" onClick={this.clearFilterSearch.bind(this)}>Clear</button>
                                                <button type="button" className="button apply-btn" value="Apply" onClick={this.applyFilter.bind(this)}>Apply </button>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                    <div className='back-to-cat'>
                                        <Link className='back-btn' to="/home"><i className="fa fa-arrow-left"></i> Back to Main</Link>
                                    </div>
                                </div>
 
                            </div>

                            <div className="field-group search-orders">
                                <input type="text" className="search-ord" name="Search" placeholder={"Search for " + searchPlaceholder} value={this.state.searchText} onChange={e => this.handleChangeSearch(e.target.value)} />
                                <button type="button" className="button" onClick={e => this.searchProduct(this.state.searchText)} ><i className="fa fa-search"></i></button>
                                <input type="button" className="button reset-btn prod-reset" value="Reset" onClick={e => this.clearSearch()} />
                                
                                <div className={this.state.filterValueList.length > 0 ? 'select-drop' : 'select-drop no-filter-list'} ref={this.dropdownRef}>
                                    {/*<select id='select_filter' onChange={this.filterChange.bind(this)}>      
                                        <option value=''> Filter By</option>
                                        <option value="Halal">Halal</option>
                                        <option value="Vegan">Vegan</option>
                                        <option value="Vegetarian">Vegetarian</option>
                                    </select>*/}

                                    <a  className={this.state.isElementVisible == true ? 'filter-btn button active' : 'filter-btn button'} onClick={this.openFilterOption}>More Filters <span className='filter-icon'><i className="fa fa-sliders" aria-hidden="true"></i></span></a>
                                     
                                     <div className={this.state.isElementVisible == true ? 'filter-bx show' : 'filter-bx'}>

                                      {this.state.filterValueList.length == 0 && 
                                        <div className='no-filter'>
                                            <p>Sorry, no filters are set for this category.</p>
                                        </div>
                                      }

                                        <div className= {this.state.isElementVisible == true ? 'filter-options active' : 'filter-options'}>
                                           {this.state.filterValueList.length > 0 && this.state.filterValueList.map((item, index)=>{
                                             return (<a className= {!this.state.filterSelectedValue.includes(item) ? 'filter-val' : 'filter-val active'} onClick={this.searchFilter.bind(this, item)}>{item} <span className='remove-filter' onClick={(e) => this.removeFilter(e, item)}></span></a>)

                                           })}
                                        
                                        </div>
                                       
                                       {this.state.filterValueList.length > 0 && 
                                        <div className='filter-btns'>
                                            <button type="button" className="button clear-btn" value="Clear Filters" onClick={this.clearFilterSearch.bind(this)}>Clear</button>
                                            <button type="button" className="button apply-btn" value="Apply Filters" onClick={this.applyFilter.bind(this)}>Apply </button>
                                        </div>

                                      }
                                    
                                    </div>
                                </div>
                            </div>

                            {this.state.filterSelectedValue.length > 0 &&  this.state.isElementVisible === false && 
                            <div className='filter-field-wrap'>
                                <h3>Filtered by:</h3>
                                <div className='filter-show-bx'>
                                {this.state.filterSelectedValue.map((item) =>(
                                    <span className='filters' onClick={(e) => this.removeFilter(e, item)}><a className='filter-x'></a>{item}</span>
                                ))}
                                    <span className='filters clr-all' onClick={this.clearFilterSearch.bind(this)}>Clear All</span>
                                </div>
                            </div>}
                            

                            <div className="checkout-cart-wrap">
                                <div className="checkout-table">
                                    <div className="table_overflow">
                                
                                        <table>
                                            <thead>
                                                <tr>
                                                    <td colSpan="3">Product</td>
                                                    <td >Unit of Sale</td>
                                                    <td className="prt-70">Info</td>
                                                    <td align='right' width={60}>Price</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                


                                        { this.state.groupProductsList && this.state.groupProductsList.map((itemCat, i) =>

                                                this.state.groupFilterList && this.state.groupFilterList.map((item, id) => {

                                                    var splitGroupName = item.split('-');


                                                    if (itemCat[item]) {
                                                        return (<>

                                                         <tr className="prt-head-tr" key={id + i}>
                                                            <td className="prt-head" data-title="Category" colSpan="9"><span className="strong">{splitGroupName[1]}</span></td>
                                                          </tr>

                                                            {itemCat[item].map((itemProduct, index) => {

                                                                return (<tr key={i}>
                                                                   <td className="prt-title" colSpan="3" data-title="Product">

                                                                 <div className={`prtf-flx ${itemProduct.productImage ? '' : ''}`}>

                                                                <span  className="prt-img" onClick={(e) => this.handleImage(i, itemProduct)}>
                                                                    <div className="prt-ovl" >
                                                                        <img src={itemProduct.productImage !=='' && itemProduct.productImage !== null ? itemProduct.productImage: NoImage}  alt={itemProduct.productDescription}
                                                                            />
                                                                    </div>
                                                                    <div className='prt-zoom-over'></div>
                                                                </span>
                                                                <span className="prt-txt">

                                                                 <h4 onClick={(e) => this.handleImage(i, itemProduct)}>{itemProduct.productDescription} ({itemProduct.productNumber})</h4>

                                                                {this.state.offerCombineProducts.length > 0 && this.state.offerCombineProducts.includes(itemProduct.productNumber) && <span className="offer-tag" onClick={this.openFreeProductListnew.bind(this)}>
                                                                        <img src={discountIcon} alt="Offer" className="tag-icon" />
                                                                        Special Offer
                                                                    </span>
                                                                   }

                                                                </span>
                                                          </div>
                                                                      
                                            
                                                        </td>
                                                        <td className="unit-sale-sec" data-title="Unit of Sale">
                                                            <span className='unit-sale-txt'>{itemProduct.packageSize}</span>
                                                        </td>
                                                        <td className="info-sec" data-title="Info">
                                                            {this.enablePopup(itemProduct) === true && <span className="prt-info" onClick={(e) => this.handlePopup(e, itemProduct)}>
                                                                <img src={darkinfo} alt="info" className="nrm" />
                                                                <img src={whiteinfo} alt="info" className="hov" />
                                                            </span>}
                                                            
                                                        </td>

                                                        <td width={60} className="prt-price" data-title="Price">{this.priceFormat(itemProduct.PDP_Price1 * 1)}</td>

                                                        <td data-title="Quantity" className="table-qty prt-qty">

                                                              {/*<input type="number" id={"product_number_"+itemProduct.productNumber} onChange={(evt) => this.handleChange(itemProduct, evt)} value={( this.state.freeProductIds !== itemProduct.productNumber && !isNaN(this.state[itemProduct.productNumber])) ? this.state[itemProduct.productNumber] : 0}  min={0} name="qty" defaultValue={0} className="form-control" onKeyPress={(e) => this.validateIntval(e)} />*/}

                                                            <div className='prod_tableQty'>
                                                                <span className="prod_QtyVal prod_QtyMin" onClick={(e) => this.dereaseQtyProduct(e, itemProduct)}>-</span>
                                                                <input className="qty-number" type="text" min="0" value="" placeholder="" min={0}  id={"product_number_"+itemProduct.productNumber} onChange={(evt) => this.handleChange(itemProduct, evt)} defaultValue={0} value={( this.state.freeProductIds !== itemProduct.productNumber && !isNaN(this.state[itemProduct.productNumber])) ? this.state[itemProduct.productNumber] : 0} />
                                                                <span className="prod_QtyVal prod_QtyPlus" onClick={(e) => this.increaseQtyProduct(e,itemProduct)}>+</span>
                                                            </div>

                                                        </td>
                                                        <td className='add-btn-fld'>
                                                         <div className='add-Cart-btn-wrap'>
                                                            {this.state[itemProduct.productNumber] !== undefined && parseInt(this.state[itemProduct.productNumber]) !== 0 && this.state.freeProductIds !== itemProduct.productNumber && <button className='add-cart-btn' onClick={(e) => this.addtoCart(e, itemProduct)} > Add to cart </button>}
                                                            </div>
                                                        </td>


                                                    </tr>)
                                                    })}</>)
                                                    }
                                                })
                                               )
                                             }


                                        { this.state.products && this.state.products.map((item, i) =>{

                                               if(item.ProductGroup === null){

                                                                return (<tr key={i}>
                                                                   <td className="prt-title" colSpan="3" data-title="Product">

                                                                 <div className={`prtf-flx ${item.productImage ? '' : ''}`}>
                                                                 <span  className="prt-img" onClick={(e) => this.handleImage(i, item)}>
                                                                    <div className="prt-ovl" >
                                                                        <img src={item.productImage !=='' && item.productImage !== null ? item.productImage: NoImage}  alt={item.productDescription}
                                                                            />
                                                                    </div>
                                                                    <div className='prt-zoom-over'></div>
                                                                </span>
                                                                <span className="prt-txt">

                                                                 <h4 onClick={(e) => this.handleImage(i, item)}>{item.productDescription} ({item.productNumber})</h4>

                                                                {this.state.offerCombineProducts.length > 0 && this.state.offerCombineProducts.includes(item.productNumber) && <span className="offer-tag">
                                                                        <img src={discountIcon} alt="Offer" className="tag-icon" />
                                                                        Special Offer
                                                                    </span>
                                                                   }

                                                                </span>
                                                          </div>
                                                                      
                                                           
                                                        </td>
                                                        <td className="unit-sale-sec" data-title="Unit of Sale">
                                                            <span className='unit-sale-txt'>{item.packageSize}</span>
                                                        </td>
                                                        <td className="info-sec" data-title="Info">
                                                            {this.enablePopup(item) === true && <span className="prt-info" onClick={(e) => this.handlePopup(e, item)}>
                                                                <img src={darkinfo} alt="info" className="nrm" />
                                                                <img src={whiteinfo} alt="info" className="hov" />
                                                            </span>}
                                                            
                                                        </td>

                                                        <td width={60} className="prt-price" data-title="Price">{this.priceFormat(item.PDP_Price1 * 1)}</td>
                                                        <td data-title="Quantity" className="table-qty prt-qty">
                                                            <input type="number" id={"product_number_"+item.productNumber} onChange={(evt) => this.handleChange(item, evt)} value={(this.state[item.productNumber] && this.state.freeProductIds !== item.productNumber) ? this.state[item.productNumber] : 0 } min={0} name="qty" defaultValue={0} className="form-control" onKeyPress={(e) => this.validateIntval(e)} />
                                                        </td>
                                                        <td className='add-btn-fld'>
                                                         <div className='add-Cart-btn-wrap'>
                                                            {this.state[item.productNumber] !== undefined && parseInt(this.state[item.productNumber]) !== 0 && this.state.freeProductIds !== item.productNumber && <button className='add-cart-btn' onClick={(e) => this.addtoCart(e, item)} >Add to cart </button>}
                                                            </div>
                                                        </td>

                                                    </tr>)}})
                                             }

                                               {this.state.viewImage != "" && this.state.viewImage}


                                                {this.state.searchText !=='' && this.state.products.length == '0' && <tr className="no-line lin-btn">
                                                    <td colSpan="3"></td>

                                                    <td colSpan="3" className='vrt-mid no_product_found' width={60}>
                                                    Sorry, no products were matched in our keyword search, please try a new search.

                                                    </td>

                                                </tr>}

                                                {this.state.searchText =='' && this.state.products.length == '0' && this.state.filterSelectedValue.length > 0 && <tr className="no-line lin-btn">
                                                    <td colSpan="3"></td>

                                                    <td colSpan="3" className='vrt-mid no_product_found' width={60}>
                                                    We couldn't find anything matching your filter search, please try again with a different search term.

                                                    </td>

                                                </tr>}

                                                 {this.state.searchText =='' && this.state.products.length == '0' && this.state.tempproducts.length == '0' && <tr className="no-line lin-btn">
                                                    <td colSpan="3"></td>

                                                    <td colSpan="3" className='vrt-mid no_product_found' width={60}>
                                                    Sorry, there are no products listed on your account, Please contact us on 01295367351 or info@tugo.co.uk for more details.

                                                    </td>
                                                  </tr>}

                                            </tbody>
                                        </table>
                                    </div>
                                      {this.state.viewInfo !== "" && this.state.viewInfo}
                                      {this.state.viewFreeProductInfo !== "" && this.state.viewFreeProductInfo}
                                </div>

                                <div className="cart-side-table" id='cart-side-table'>
                                    {this.state.reloadCart && this.state.loading === false && 
                                    this.loadCartItems()
                                    }
                                    {this.state.loading === true && this.state.reloadCart === false && <div>Loading...</div>}

                                </div>

                            </div>
                        </div>

                {this.state.clear_cart === true && 
                  <div className='custom-alert-pop common_alert_popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Clear Cart</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>Are your sure you want to clear your cart?</p>
                                <div className='alert-buttons'>
                                    <a className="popup-alert-btn button" onClick={this.clearCart.bind(this)}>Ok</a>
                                    <a onClick={this.popupClose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

               {this.state.delete_item_popup === true && 
                  <div className='custom-alert-pop common_alert_popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Remove Item</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>Are you sure you want to delete this item?</p>

                                <div className='alert-buttons'>
                                    <a className="popup-alert-btn button" onClick={this.clearSingleItem.bind(this)}>Ok</a>
                                    <a onClick={this.popupClose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
                

              {this.state.delete_item_popup_free === true && 
                  <div className='custom-alert-pop common_alert_popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Remove Item</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>{this.state.delete_item_popup_free_message}</p>
                                <div className='alert-buttons'>
                                    <a className="popup-alert-btn button" onClick={this.clearSingleItemFree.bind(this)}>Ok</a>
                                    <a onClick={this.popupClose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

            
            {this.state.common_alert_popup === true && 
                  <div className='custom-alert-pop common_alert_popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Alert</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>{this.state.common_alert_message}</p>

                                <div className='alert-buttons'>
                                    <a onClick={this.freeProductClear.bind(this)} className="popup-alert-btn button">OK</a>
                                    <a onClick={this.popupClose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
              </div> }

            {this.state.decrease_alert_popup === true && 
                  <div className='custom-alert-pop common_alert_popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Alert</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>{this.state.decrease_alert_popup_message}</p>
                                <div className='alert-buttons'>
                                    <a className="popup-alert-btn button" onClick={this.removeMultipleFreeProduct.bind(this)}>OK</a>
                                    <a onClick={this.popupClose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> }

              {this.state.delete_item_alert_popup === true && 
                  <div className='custom-alert-pop common_alert_popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Alert</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>{this.state.delete_item_alert_message}</p>

                                <div className='alert-buttons'>
                                    <a className="popup-alert-btn button" onClick={this.removeSingleOfferProduct.bind(this)}>OK</a>
                                    <a onClick={this.popupClose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
                </section>
                </main>
                }

                {this.state.freeProductOpen === true && this.state.freeProductData.data !== undefined && this.state.freeProductData.data.length > 0 && 

                 <FreeProductPopup addfreepro={this.addFreeProduct.bind(this)} freeval = {this.state.checkedItems} productQty={this.state.offerProductQty} freeProduct ={this.state.freeProductData} freeProduct1={this.state.freeProductDataFour} freeProduct2={this.state.freeProductDataFive} productValueIndex={this.state.productValueIndex} productQtyRemaing={this.state.offerproductQtyRemaing} closefreepro={this.CloseFreePopup.bind(this)} accountObjective1 = {this.state.accountObjective1} accountObjective2 = {this.state.accountObjective2}/>
                }

                {this.state.freeProductListOpen === true  && this.state.offerProductData.length > 0 && 
                 <FreeProductListPopup addfreepro={this.addFreeProduct.bind(this)} freeval = {this.state.checkedItems} productQty={this.state.offerProductQty} freeProduct ={this.state.freeProductData} freeProduct1={this.state.freeProductDataFour} freeProduct2={this.state.freeProductDataFive} productValueIndex={this.state.productValueIndex} productQtyRemaing={this.state.offerproductQtyRemaing} closefreepro={this.CloseFreePopup.bind(this)} offerProductData = {this.state.offerProductData} />
                }

                
                {this.state.minmumAmountError === true && 
                  <div className='custom-alert-pop common_alert_popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Minimum Cart Value</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>{minmumAmount}</p>

                                <div className='alert-buttons'>
                                    <a className="popup-alert-btn button" onClick={this.popupClose.bind(this)}>OK</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>} 

                {this.state.minimumOrderAmounterror === true && 
                  <div className='custom-alert-pop common_alert_popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Minimum Cart Value</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>{minmumAmount}</p>

                                <div className='alert-buttons'>
                                    <a className="popup-alert-btn button" onClick={this.popupClose.bind(this)}>OK</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>} 

                {this.state.loading && <main className='main-section'><Loader propsClassName="load-lag" /></main>}           

                <Footer />
            </>
        );
    }
}

export default Checkout;